"use strict";
(self["webpackChunkshine_on"] = self["webpackChunkshine_on"] || []).push([[233],{

/***/ 8047:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5713);
/* harmony import */ var _node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(103);
/* harmony import */ var _node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.copy-code {\n  margin  : auto;\n  position: relative;\n}\n.status-tooltip {\n  padding      : .5rem .5rem;\n  margin       : auto;\n  position     : absolute;\n  top          : -2rem;\n  right        : 0;\n  left         : 0;\n  font-weight  : 500;\n  color        : white;\n  background   : rgba(134, 122, 179, .75);\n  border-radius: 1.5rem;\n}\n", ""]);
// Exports
/* harmony default export */ __webpack_exports__["Z"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 3572:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5713);
/* harmony import */ var _node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(103);
/* harmony import */ var _node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/* Gallery in size modal - hide thumbnails and show pagination below like mobile */\n.size-modal-wrapper .size-modal__product-gallery .gallery__thumbnails {\n  display: none !important;\n}\n.size-modal-wrapper .size-modal__product-gallery .gallery {\n  display: block !important;\n  max-width: 28rem !important;\n}\n.size-modal-wrapper\n  .size-modal__product-gallery\n  .gallery__main\n  .splide__pagination {\n  position: static !important;\n  margin-top: 1rem;\n  display: flex !important;\n  justify-content: center !important;\n  gap: 0.5rem;\n  transform: none;\n}\n.size-modal-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Mobile responsive styles */\n@media (max-width: 768px) {\n  /* Hide the overlay completely on mobile */\n.vm--overlay {\n    display: none !important;\n}\n\n  /* Full screen modal on mobile - no margins, no overlay */\n.vm--container .vm--modal {\n    width: 100vw !important;\n    height: 100vh !important;\n    max-width: 100vw !important;\n    max-height: 100vh !important;\n    margin: 0 !important;\n    padding: 0 !important;\n    border-radius: 0 !important;\n    top: 0 !important;\n    left: 0 !important;\n    transform: none !important;\n    position: fixed !important;\n    z-index: 9999 !important;\n}\n\n  /* Override inline styles applied by vue-js-modal */\n.size-modal-wrapper.vm--modal {\n    top: 0 !important;\n    left: 0 !important;\n    width: 100vw !important;\n    height: 100vh !important;\n    display: block !important;\n}\n\n  /* Ensure the modal content fills the screen */\n.size-modal-wrapper .vm--modal {\n    padding: 0 !important;\n}\n\n  /* Override the size-modal-wrapper padding on mobile */\n.size-modal-wrapper {\n    padding: 0 !important;\n}\n}\n", ""]);
// Exports
/* harmony default export */ __webpack_exports__["Z"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 7766:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5713);
/* harmony import */ var _node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(103);
/* harmony import */ var _node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.vm--container .vm--modal[data-v-32f7d4a7] {\n  padding: 20px !important;\n}\n.size-modal[data-v-32f7d4a7] {\n  position: relative;\n}\n.size-modal__title[data-v-32f7d4a7] {\n  font-size: 1.5rem;\n  margin-bottom: 1rem;\n  color: #333;\n}\n.size-modal__product[data-v-32f7d4a7] {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n  padding: 0;\n  background: transparent;\n  border: none;\n  overflow: hidden;\n}\n.size-modal__product-content[data-v-32f7d4a7] {\n  column-gap: 2rem;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  padding-top: 0.5rem;\n  min-height: 500px;\n}\n.size-modal__product-gallery[data-v-32f7d4a7] {\n  flex-shrink: 0;\n  max-width: 100%;\n}\n\n/* Desktop styles for modal content */\n.size-modal__content[data-v-32f7d4a7] {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n  padding: 2rem;\n  position: relative;\n  max-height: 80vh;\n  justify-content: center;\n}\n\n/* Mobile responsive styles for modal content */\n@media (max-width: 768px) {\n.size-modal[data-v-32f7d4a7] {\n    height: 100vh;\n    display: flex;\n    flex-direction: column;\n    border-radius: 0;\n}\n.size-modal__content[data-v-32f7d4a7] {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    padding: 2rem;\n    padding-bottom: 2rem;\n    max-height: unset;\n}\n.size-modal__product-content[data-v-32f7d4a7] {\n    display: flex;\n    flex-direction: column;\n    gap: 1.5rem;\n    padding-top: 0;\n    min-height: auto;\n    flex: 1;\n    text-align: center;\n}\n.size-modal__product-gallery[data-v-32f7d4a7] {\n    order: 1;\n    max-width: 100%;\n    height: auto;\n    flex-shrink: 0;\n}\n.size-modal__product-details[data-v-32f7d4a7] {\n    order: 2;\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n}\n.size-modal__product-price-section[data-v-32f7d4a7] {\n    padding-bottom: 0;\n}\n\n  /* Gallery mobile styles */\n.size-modal__product-gallery .gallery[data-v-32f7d4a7] {\n    min-height: 300px;\n}\n.size-modal__product-gallery .gallery__main[data-v-32f7d4a7] {\n    height: 100%;\n}\n\n  /* Product form mobile spacing */\n.size-modal__product-form[data-v-32f7d4a7] {\n    margin-top: auto;\n    padding-top: 0;\n}\n.size-modal__product-form .product__details-form[data-v-32f7d4a7] {\n    margin-top: 0;\n}\n.size-modal__product-form .product__details-form .product__form-buttons[data-v-32f7d4a7] {\n    justify-content: center;\n}\n.size-modal__product-form\n    .product__details-form\n    .product__form-buttons\n    button[data-v-32f7d4a7] {\n    width: auto;\n    min-width: 225px;\n}\n\n  /* Close button positioning for mobile */\n.vm--close[data-v-32f7d4a7] {\n    right: 10px !important;\n    top: 10px !important;\n}\n}\n.size-modal__product-image[data-v-32f7d4a7] {\n  flex-shrink: 0;\n  max-width: 400px;\n  height: auto;\n}\n.size-modal__product-img[data-v-32f7d4a7] {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 4px;\n}\n.size-modal__product-details[data-v-32f7d4a7] {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  justify-content: center;\n}\n.size-modal__product-title[data-v-32f7d4a7] {\n  font-size: 2.25rem;\n  margin: 0;\n  font-weight: 700;\n  text-transform: uppercase;\n  color: var(--black);\n  text-shadow: 0 1px 3px var(--smoke);\n}\n.size-modal__product-price-section[data-v-32f7d4a7] {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  font-size: var(--text-xl);\n  padding-bottom: 1rem;\n}\n.size-modal__product-price[data-v-32f7d4a7] {\n  font-size: 1.6875rem;\n  margin: 0;\n  color: var(--black);\n  font-weight: 400;\n}\n.size-modal__product-price--sale[data-v-32f7d4a7] {\n  color: #999;\n  margin-left: 0.5rem;\n  text-decoration: line-through;\n}\n.size-modal__product-form .product__details-form[data-v-32f7d4a7] {\n  padding-bottom: 0;\n}\n.size-modal__product-form .product__details-form .product__form-buttons button[data-v-32f7d4a7] {\n  width: auto;\n  min-width: 225px;\n}\n.size-modal__full-details a[data-v-32f7d4a7] {\n  text-decoration: underline;\n}\n.size-modal__actions[data-v-32f7d4a7] {\n  display: flex;\n  justify-content: center;\n  gap: 1rem;\n}\n", ""]);
// Exports
/* harmony default export */ __webpack_exports__["Z"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 5723:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5713);
/* harmony import */ var _node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(103);
/* harmony import */ var _node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.product__installments-wrapper:not(:first-of-type) {\n  padding-top: .35rem;\n}\n.product__installments-text {\n  height     : 1.275rem;\n  display    : inline-block;\n  font-size  : var(--text-xxs);\n  line-height: var(--line-xxs);\n}\n.product__installments-text strong {\n  margin: 0 .25rem;\n}\n.product__installments-image {\n  height       : .75rem;\n  margin-bottom: -.05rem;\n}\n@media (min-width: 768px) {\n.product__installments {\n    padding: .15rem 0 0;\n}\n.product__installments-wrapper:not(:first-of-type) {\n    padding-top: 0;\n    margin-top : -1rem;\n}\n}\n", ""]);
// Exports
/* harmony default export */ __webpack_exports__["Z"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 4453:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5713);
/* harmony import */ var _node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(103);
/* harmony import */ var _node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/* Gallery in size modal - hide thumbnails and show pagination below like mobile */\n.size-modal-wrapper .size-modal__product-gallery .gallery__thumbnails {\n  display: none !important;\n}\n.size-modal-wrapper .size-modal__product-gallery .gallery {\n  display: block !important;\n  max-width: 28rem !important;\n}\n.size-modal-wrapper\n  .size-modal__product-gallery\n  .gallery__main\n  .splide__pagination {\n  position: static !important;\n  margin-top: 1rem;\n  display: flex !important;\n  justify-content: center !important;\n  gap: 0.5rem;\n  transform: none;\n}\n.size-modal-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Mobile responsive styles */\n@media (max-width: 768px) {\n  /* Hide the overlay completely on mobile */\n.vm--overlay {\n    display: none !important;\n}\n\n  /* Full screen modal on mobile - no margins, no overlay */\n.vm--container .vm--modal {\n    width: 100vw !important;\n    height: 100vh !important;\n    max-width: 100vw !important;\n    max-height: 100vh !important;\n    margin: 0 !important;\n    padding: 0 !important;\n    border-radius: 0 !important;\n    top: 0 !important;\n    left: 0 !important;\n    transform: none !important;\n    position: fixed !important;\n    z-index: 9999 !important;\n}\n\n  /* Override inline styles applied by vue-js-modal */\n.size-modal-wrapper.vm--modal {\n    top: 0 !important;\n    left: 0 !important;\n    width: 100vw !important;\n    height: 100vh !important;\n    display: block !important;\n}\n\n  /* Ensure the modal content fills the screen */\n.size-modal-wrapper .vm--modal {\n    padding: 0 !important;\n}\n\n  /* Override the size-modal-wrapper padding on mobile */\n.size-modal-wrapper {\n    padding: 0 !important;\n}\n}\n", ""]);
// Exports
/* harmony default export */ __webpack_exports__["Z"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 7744:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5713);
/* harmony import */ var _node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(103);
/* harmony import */ var _node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.vm--container .vm--modal[data-v-7413fe77] {\n  padding: 20px !important;\n}\n.size-modal[data-v-7413fe77] {\n  position: relative;\n}\n.size-modal__title[data-v-7413fe77] {\n  font-size: 1.5rem;\n  margin-bottom: 1rem;\n  color: #333;\n}\n.size-modal__product[data-v-7413fe77] {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n  padding: 0;\n  background: transparent;\n  border: none;\n  overflow: hidden;\n}\n.size-modal__product-content[data-v-7413fe77] {\n  column-gap: 2rem;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  padding-top: 0.5rem;\n  min-height: 500px;\n}\n.size-modal__product-gallery[data-v-7413fe77] {\n  flex-shrink: 0;\n  max-width: 100%;\n}\n\n/* Desktop styles for modal content */\n.size-modal__content[data-v-7413fe77] {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n  padding: 2rem;\n  position: relative;\n  max-height: 80vh;\n  justify-content: center;\n}\n\n/* Mobile responsive styles for modal content */\n@media (max-width: 768px) {\n.size-modal[data-v-7413fe77] {\n    height: 100vh;\n    display: flex;\n    flex-direction: column;\n    border-radius: 0;\n}\n.size-modal__content[data-v-7413fe77] {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    padding: 2rem;\n    padding-bottom: 2rem;\n    max-height: unset;\n}\n.size-modal__product-content[data-v-7413fe77] {\n    display: flex;\n    flex-direction: column;\n    gap: 1.5rem;\n    padding-top: 0;\n    min-height: auto;\n    flex: 1;\n    text-align: center;\n}\n.size-modal__product-gallery[data-v-7413fe77] {\n    order: 1;\n    max-width: 100%;\n    height: auto;\n    flex-shrink: 0;\n}\n.size-modal__product-details[data-v-7413fe77] {\n    order: 2;\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n}\n.size-modal__product-price-section[data-v-7413fe77] {\n    padding-bottom: 0;\n}\n\n  /* Gallery mobile styles */\n.size-modal__product-gallery .gallery[data-v-7413fe77] {\n    min-height: 300px;\n}\n.size-modal__product-gallery .gallery__main[data-v-7413fe77] {\n    height: 100%;\n}\n\n  /* Product form mobile spacing */\n.size-modal__product-form[data-v-7413fe77] {\n    margin-top: auto;\n    padding-top: 0;\n}\n.size-modal__product-form .product__details-form[data-v-7413fe77] {\n    margin-top: 0;\n}\n.size-modal__product-form .product__details-form .product__form-buttons[data-v-7413fe77] {\n    justify-content: center;\n}\n.size-modal__product-form\n    .product__details-form\n    .product__form-buttons\n    button[data-v-7413fe77] {\n    width: auto;\n    min-width: 225px;\n}\n\n  /* Close button positioning for mobile */\n.vm--close[data-v-7413fe77] {\n    right: 10px !important;\n    top: 10px !important;\n}\n}\n.size-modal__product-image[data-v-7413fe77] {\n  flex-shrink: 0;\n  max-width: 400px;\n  height: auto;\n}\n.size-modal__product-img[data-v-7413fe77] {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 4px;\n}\n.size-modal__product-details[data-v-7413fe77] {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  justify-content: center;\n}\n.size-modal__product-title[data-v-7413fe77] {\n  font-size: 2.25rem;\n  margin: 0;\n  font-weight: 700;\n  text-transform: uppercase;\n  color: var(--black);\n  text-shadow: 0 1px 3px var(--smoke);\n}\n.size-modal__product-price-section[data-v-7413fe77] {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  font-size: var(--text-xl);\n  padding-bottom: 1rem;\n}\n.size-modal__product-price[data-v-7413fe77] {\n  font-size: 1.6875rem;\n  margin: 0;\n  color: var(--black);\n  font-weight: 400;\n}\n.size-modal__product-price--sale[data-v-7413fe77] {\n  color: #999;\n  margin-left: 0.5rem;\n  text-decoration: line-through;\n}\n.size-modal__product-form .product__details-form[data-v-7413fe77] {\n  padding-bottom: 0;\n}\n.size-modal__product-form .product__details-form .product__form-buttons button[data-v-7413fe77] {\n  width: auto;\n  min-width: 225px;\n}\n.size-modal__full-details a[data-v-7413fe77] {\n  text-decoration: underline;\n}\n.size-modal__actions[data-v-7413fe77] {\n  display: flex;\n  justify-content: center;\n  gap: 1rem;\n}\n", ""]);
// Exports
/* harmony default export */ __webpack_exports__["Z"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 9863:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5713);
/* harmony import */ var _node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(103);
/* harmony import */ var _node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n*[data-v-1b12723a] {\n  will-change        : height, padding-top, padding-bottom, margin-top, margin-bottom, opacity;\n  transform          : translateZ(0);\n  backface-visibility: hidden;\n  perspective        : 1000px;\n}\n.expand-enter-active[data-v-1b12723a],\n.expand-leave-active[data-v-1b12723a] {\n  transition: height .4s ease-in-out,\n              padding-top .4s ease-in-out,\n              padding-bottom .4s ease-in-out,\n              margin-top .4s ease-in-out,\n              margin-bottom .4s ease-in-out,\n              opacity .2s ease-in-out;\n  overflow  : hidden;\n}\n.expand-enter[data-v-1b12723a],\n.expand-leave-to[data-v-1b12723a] {\n  height        : 0;\n  padding-top   : 0;\n  padding-bottom: 0;\n  margin-top    : 0;\n  margin-bottom : 0;\n  opacity       : 0;\n}\n", ""]);
// Exports
/* harmony default export */ __webpack_exports__["Z"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 1955:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {


// EXTERNAL MODULE: ./node_modules/quicklink/dist/quicklink.mjs
var quicklink = __webpack_require__(933);
// EXTERNAL MODULE: ./node_modules/lazysizes/lazysizes.js
var lazysizes = __webpack_require__(3785);
var lazysizes_default = /*#__PURE__*/__webpack_require__.n(lazysizes);
// EXTERNAL MODULE: ./node_modules/lazysizes/plugins/unveilhooks/ls.unveilhooks.js
var ls_unveilhooks = __webpack_require__(6476);
// EXTERNAL MODULE: ./src/scripts/utils/breakpoints.js
var breakpoints = __webpack_require__(9508);
;// CONCATENATED MODULE: ./src/scripts/utils/lazyloading.js



 // Quicklink

(0,quicklink/* listen */.o)({
  ignores: [/\/logout/, uri => uri.includes('/account'), uri => uri.includes('.zip'), uri => uri.includes('/cart'), (uri, elem) => elem.hasAttribute('noprefetch')]
}); // Lazysizes

(lazysizes_default()).cfg.lazyClass = 'lazyload';
(lazysizes_default()).cfg.customMedia = { ...breakpoints/* mq_breakpoints */.RS
}; // Custom
// Fire event called 'elementinview' for elements with 'lazyscript' class

document.addEventListener('DOMContentLoaded', () => {
  const lazyElements = [].slice.call(document.querySelectorAll('.lazyscript'));

  if ('IntersectionObserver' in window) {
    const options = {
      threshold: 0.1
    };
    const lazyElementObserver = new IntersectionObserver((entries, options) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const lazyTarget = entry.target;
          const event = new Event('elementinview');
          lazyTarget.dispatchEvent(event);
          lazyElementObserver.unobserve(lazyTarget);
        }
      });
    });
    lazyElements.forEach(el => {
      lazyElementObserver.observe(el);
    });
  } else {
    console.warn('IntersectionObserver not found. Dispatching all events..');
    const lazyElements = [].slice.call(document.querySelectorAll('.lazyscript'));
    lazyElements.forEach(el => {
      const event = new Event('elementinview');
      el.dispatchEvent(event);
    });
  }
}, {
  passive: true
});
// EXTERNAL MODULE: ./src/scripts/vue/main.js + 1 modules
var main = __webpack_require__(3200);
// EXTERNAL MODULE: ./node_modules/vue/dist/vue.min.js
var vue_min = __webpack_require__(9346);
var vue_min_default = /*#__PURE__*/__webpack_require__.n(vue_min);
;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/CopyText.vue?vue&type=template&id=ef08b944&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"copy-code btn--small",attrs:{"aria-label":"copy promo code"},on:{"click":function($event){return _vm.copyPromoCode(_vm.code)}}},[_c('transition',{attrs:{"name":"fade"}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"status-tooltip",domProps:{"textContent":_vm._s(_vm.text)}})]),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/CopyText.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var CopyTextvue_type_script_lang_js_ = ({
  name: 'CopyText',
  props: ['code'],

  data() {
    return {
      text: '',
      show: false
    };
  },

  methods: {
    copyPromoCode(code) {
      navigator.clipboard.writeText(code).then(() => {
        this.text = 'code copied';
        this.show = true;
      }, () => {
        this.text = 'copy error';
        this.show = true;
      });
      setTimeout(() => {
        this.show = false;
      }, 2000);
    }

  }
});
;// CONCATENATED MODULE: ./src/scripts/vue/components/CopyText.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_CopyTextvue_type_script_lang_js_ = (CopyTextvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js
var injectStylesIntoStyleTag = __webpack_require__(3379);
var injectStylesIntoStyleTag_default = /*#__PURE__*/__webpack_require__.n(injectStylesIntoStyleTag);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/styleDomAPI.js
var styleDomAPI = __webpack_require__(7795);
var styleDomAPI_default = /*#__PURE__*/__webpack_require__.n(styleDomAPI);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/insertBySelector.js
var insertBySelector = __webpack_require__(569);
var insertBySelector_default = /*#__PURE__*/__webpack_require__.n(insertBySelector);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js
var setAttributesWithoutAttributes = __webpack_require__(3565);
var setAttributesWithoutAttributes_default = /*#__PURE__*/__webpack_require__.n(setAttributesWithoutAttributes);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/insertStyleElement.js
var insertStyleElement = __webpack_require__(9216);
var insertStyleElement_default = /*#__PURE__*/__webpack_require__.n(insertStyleElement);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/styleTagTransform.js
var styleTagTransform = __webpack_require__(4589);
var styleTagTransform_default = /*#__PURE__*/__webpack_require__.n(styleTagTransform);
// EXTERNAL MODULE: ./node_modules/@ps-devs/shopify-webpack/node_modules/css-loader/dist/cjs.js??clonedRuleSet-5[0].rules[0].use[1]!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/CopyText.vue?vue&type=style&index=0&lang=css&
var CopyTextvue_type_style_index_0_lang_css_ = __webpack_require__(8047);
;// CONCATENATED MODULE: ./node_modules/style-loader/dist/cjs.js!./node_modules/@ps-devs/shopify-webpack/node_modules/css-loader/dist/cjs.js??clonedRuleSet-5[0].rules[0].use[1]!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/CopyText.vue?vue&type=style&index=0&lang=css&

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (styleTagTransform_default());
options.setAttributes = (setAttributesWithoutAttributes_default());

      options.insert = insertBySelector_default().bind(null, "head");
    
options.domAPI = (styleDomAPI_default());
options.insertStyleElement = (insertStyleElement_default());

var update = injectStylesIntoStyleTag_default()(CopyTextvue_type_style_index_0_lang_css_/* default */.Z, options);




       /* harmony default export */ var components_CopyTextvue_type_style_index_0_lang_css_ = (CopyTextvue_type_style_index_0_lang_css_/* default */.Z && CopyTextvue_type_style_index_0_lang_css_/* default.locals */.Z.locals ? CopyTextvue_type_style_index_0_lang_css_/* default.locals */.Z.locals : undefined);

;// CONCATENATED MODULE: ./src/scripts/vue/components/CopyText.vue?vue&type=style&index=0&lang=css&

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1900);
;// CONCATENATED MODULE: ./src/scripts/vue/components/CopyText.vue



;


/* normalize component */

var component = (0,componentNormalizer/* default */.Z)(
  components_CopyTextvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CopyText = (component.exports);
;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/InstantSearch.vue?vue&type=template&id=1d7de746&
var InstantSearchvue_type_template_id_1d7de746_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"instant-search"},[_c('TransitionExpand',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.search_active),expression:"search_active"}],staticClass:"header-dropdown__search"},[_c('form',{attrs:{"action":_vm.action_url,"method":"get","role":"search"}},[_c('div',{staticClass:"header-dropdown__search-form"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.query),expression:"query"}],ref:"input",staticClass:"ss__autocomplete__input instant-search__input",attrs:{"placeholder":"Search our store","type":"search","name":"q","id":"InstantSearch","autocomplete":"off"},domProps:{"value":(_vm.query)},on:{"keyup":function($event){return _vm.search($event)},"input":function($event){if($event.target.composing){ return; }_vm.query=$event.target.value}}})])])])]),_vm._v(" "),(_vm.search_active && _vm.all_empty == false)?_c('div',{staticClass:"instant-search__wrapper"},[_c('div',{staticClass:"instant-search__results"},[(_vm.suggestions.length)?_c('section',{staticClass:"results-group suggestions"},[_vm._m(0),_vm._v(" "),_c('ul',{staticClass:"result-group__ul"},_vm._l((_vm.suggestions),function(suggestion,idx){return _c('li',{key:idx,staticClass:"result-group__li",on:{"click":function($event){return _vm.searchSuggestion(suggestion)}}},[_vm._v("\n            "+_vm._s(suggestion)+"\n          ")])}),0)]):_vm._e(),_vm._v(" "),(_vm.pages.length)?_c('section',{staticClass:"results-group pages"},[_vm._m(1),_vm._v(" "),_c('ul',{staticClass:"result-group__ul"},_vm._l((_vm.pages),function(page,idx){return _c('li',{key:idx,staticClass:"result-group__li"},[_c('a',{attrs:{"href":page.url}},[_vm._v("\n              "+_vm._s(page.title)+"\n            ")])])}),0)]):_vm._e(),_vm._v(" "),(_vm.products.length)?_c('section',{staticClass:"results-group products"},[_vm._m(2),_vm._v(" "),_c('ul',{staticClass:"result-group__ul"},_vm._l((_vm.products),function(product,idx){return _c('li',{key:idx,staticClass:"result-group__li"},[_c('a',{staticClass:"product-item__link result-product",attrs:{"href":("/collections/" + _vm.handle + "/products/" + (product.handle))}},[_c('div',{staticClass:"product-item__image-wrapper"},[_c('VImg',{attrs:{"media":product.images_info[0]}})],1),_vm._v(" "),_c('div',{staticClass:"product-item__details-wrapper"},[_c('span',{staticClass:"product-item__title"},[_vm._v("\n                  "+_vm._s(product.title)+"\n                ")]),_vm._v(" "),_c('p',{staticClass:"product-item__price"},[_vm._v("\n                  $"+_vm._s(product.variants[0].price)+"\n                ")])])])])}),0)]):_vm._e()]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.products_found),expression:"products_found"}],staticClass:"results-all-products btn--full btn--small",attrs:{"type":"submit"},on:{"click":function($event){return _vm.submitForm()}}},[_vm._v("\n      View All "+_vm._s(_vm.products_found)+" Products\n    ")])]):_vm._e()],1)}
var InstantSearchvue_type_template_id_1d7de746_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"results-group__header"},[_c('span',[_vm._v("Suggestions")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"results-group__header"},[_c('span',[_vm._v("Pages")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"results-group__header"},[_c('span',[_vm._v("Products")])])}]


;// CONCATENATED MODULE: ./src/scripts/vue/components/InstantSearch.vue?vue&type=template&id=1d7de746&

// EXTERNAL MODULE: ./src/scripts/vue/components/VImg.vue + 3 modules
var VImg = __webpack_require__(3133);
// EXTERNAL MODULE: ./src/scripts/vue/transitions/TransitionExpand.vue + 5 modules
var TransitionExpand = __webpack_require__(6719);
// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__(9046);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/InstantSearch.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var InstantSearchvue_type_script_lang_js_ = ({
  components: {
    VImg: VImg/* default */.Z,
    TransitionExpand: TransitionExpand/* default */.Z
  },
  props: ['terms', 'search_active', 'action_url'],

  data() {
    return {
      query: '',
      suggestions: [],
      pages: [],
      products: [],
      products_found: 0,
      all_empty: true
    };
  },

  watch: {
    search_active: {
      immediate: true,

      handler() {
        if (this.search_active) {
          this.$nextTick(() => {
            this.$refs.input.focus();
          });
        }
      }

    }
  },
  methods: {
    search: debounce_default()(function (e) {
      this.products = []; // Escape

      if (e.key === 'Escape' || e.keyCode === 27) {
        this.query = '';
        this.all_empty = true;
        this.$refs.input.blur();
        this.$parent.toggleSearch();
        return;
      } // Reset


      if (this.query.length < 3) {
        this.all_empty = true;
        return;
      } // BCSF Endpoint


      let url = new URL('https://services.mybcapps.com/bc-sf-filter/search/suggest'); // Request options

      let params = {
        shop: 'shineon-co-nz.myshopify.com',
        q: this.query,
        suggest_types: ['products', 'pages', 'collections'],
        product_limit: 3
      }; // Create query string from params object

      Object.keys(params).forEach(key => {
        url.searchParams.append(key, params[key]);
      }); // Send request

      fetch(url).then(response => response.json()).then(data => {
        this.all_empty = data.all_empty;
        this.suggestions = data.suggestions;
        this.pages = data.pages;
        this.collections = data.collections;
        this.products = data.products;
        this.products_found = data.total_product;
      }).catch(error => {
        console.log('error', error);
      });
    }, 100),

    searchSuggestion(suggestion) {
      this.query = suggestion;
      this.$refs.input.value = suggestion;
      this.$parent.$el.querySelector('form[action="/search"]').submit();
    },

    submitForm() {
      this.$parent.$el.querySelector('form[action="/search"]').submit();
    }

  }
});
;// CONCATENATED MODULE: ./src/scripts/vue/components/InstantSearch.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_InstantSearchvue_type_script_lang_js_ = (InstantSearchvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./src/scripts/vue/components/InstantSearch.vue





/* normalize component */
;
var InstantSearch_component = (0,componentNormalizer/* default */.Z)(
  components_InstantSearchvue_type_script_lang_js_,
  InstantSearchvue_type_template_id_1d7de746_render,
  InstantSearchvue_type_template_id_1d7de746_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var InstantSearch = (InstantSearch_component.exports);
// EXTERNAL MODULE: ./node_modules/lodash-es/throttle.js + 14 modules
var throttle = __webpack_require__(5325);
;// CONCATENATED MODULE: ./src/scripts/sections/header.js





let annoucementBarWaypoint = 75;
window.PSTheme.Vue.Header = new (vue_min_default())({
  name: 'Header',
  components: {
    CopyText: CopyText,
    InstantSearch: InstantSearch
  },
  data: {
    cartCount: 0,
    secondMenuIdx: null,
    thirdMenuIdx: null
  },

  mounted() {
    this.cartCount = this.$refs.cart_count.dataset.count || 0;

    if (window.PSTheme.Settings.Outlet === false) {
      let wishlist_btn = document.createComment(` include 'wishlist-link' `);
      this.$refs['insert-wishlist'].appendChild(wishlist_btn);
    }
  },

  methods: {
    openMenu() {
      this.secondMenuIdx = null;
      this.thirdMenuIdx = null;
      this.$actions.openMenu();
    },

    toggleMenu() {
      this.secondMenuIdx = null;
      this.thirdMenuIdx = null;
      this.$actions.toggleMenu();
    },

    toggleSecondMenu(secondMenuKey) {
      if (this.$store.menuActive == false) {
        this.$actions.openMenu();
      }

      if (this.secondMenuIdx !== secondMenuKey) {
        this.secondMenuIdx = secondMenuKey;
      } else {
        this.secondMenuIdx = null;

        if (window.matchMedia(breakpoints/* mq_breakpoints.--tablet-lg-up */.RS["--tablet-lg-up"]).matches) {
          this.toggleMenu();
        }
      }

      this.thirdMenuIdx = null;
    },

    toggleThirdMenu(thirdMenuKey, secondMenuLink) {
      if (this.thirdMenuIdx !== thirdMenuKey) {
        this.thirdMenuIdx = thirdMenuKey;
      } else {
        this.thirdMenuIdx = null;
      }
    },

    toggleSearch() {
      this.$actions.toggleSearch();
    },

    toggleNotifications() {
      this.$actions.toggleNotifications();
    },

    toggleDrawer() {
      if (window.PSTheme.Drawer) {
        window.PSTheme.Drawer.toggle();
      }
    },

    closeAnnouncementOnScroll: (0,throttle/* default */.Z)(function () {
      this.$store.closeAnnouncement = window.pageYOffset >= annoucementBarWaypoint;
    }, 250),

    updateCartCount(amount) {
      this.cartCount = Number(this.cartCount) + amount;
    },

    setCartCount(cart_count) {
      this.cartCount = cart_count;
    }

  }
}).$mount('.app__header');
;// CONCATENATED MODULE: ./src/scripts/sections/footer.js


window.PSTheme.Vue.Footer = new (vue_min_default())({
  name: 'Footer',
  components: {
    TransitionExpand: TransitionExpand/* default */.Z
  },
  data: {
    footerMenuIdx: null
  },
  methods: {
    toggleFooterMenu(loopIdx) {
      if (loopIdx == this.footerMenuIdx) {
        this.footerMenuIdx = null;
      } else {
        this.footerMenuIdx = loopIdx;
      }
    }

  }
}).$mount('.app__footer');
// EXTERNAL MODULE: ./node_modules/local-storage/local-storage.js
var local_storage = __webpack_require__(9982);
var local_storage_default = /*#__PURE__*/__webpack_require__.n(local_storage);
;// CONCATENATED MODULE: ./src/scripts/sections/popup-banner.js


window.PSTheme.Vue.PopupBanner = new (vue_min_default())({
  name: 'PopupBanner',

  data() {
    return {
      showPopup: !local_storage_default()('PSPopupBannerViewed')
    };
  },

  methods: {
    setPopupBannerViewed() {
      this.showPopup = false;
      local_storage_default()('PSPopupBannerViewed', true);
    }

  },

  mounted() {
    window.onload = function () {
      const popupClose = document.getElementById('lpclose');

      if (popupClose) {
        popupClose.addEventListener('click', event => {
          const el = document.getElementById('_lpSurveyPopover');

          if (el.classList.contains('block')) {
            el.classList.remove('block');
          }
        });
      } // Select element with box class, assign to box variable
      // Detect all clicks on the document


      const box = document.getElementById('_lpSurveyPopover');

      if (box) {
        document.addEventListener('click', event => {
          // If user clicks inside the element, do nothing
          if (event.target.closest('#_lpSurveyPopover')) {
            if (box.classList.contains('block')) {
              box.classList.remove('block');
            }
          }
        });
      }
    };
  }

}).$mount('.app__popup-banner');
// EXTERNAL MODULE: ./node_modules/vue-js-modal/dist/index.js
var dist = __webpack_require__(412);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/CartDrawer.vue?vue&type=template&id=f45abcce&
var CartDrawervue_type_template_id_f45abcce_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cart-drawer"},[_c('CartDrawerHeader'),_vm._v(" "),_c('div',{staticClass:"cart-drawer__body"},[_c('CartDrawerContent',{attrs:{"cart":_vm.cart,"loading":_vm.loading,"enable-upsell":_vm.enableUpsell,"upsell-products":_vm.upsellProducts,"upsell-title":_vm.upsellTitle,"enable-cross-sell":_vm.enableCrossSell,"cross-sell-products":_vm.crossSellProducts,"cross-sell-title":_vm.crossSellTitle},on:{"cart-updated":_vm.handleCartUpdate}})],1),_vm._v(" "),_c('CartDrawerFooter',{attrs:{"cart":_vm.cart},on:{"cart-updated":_vm.handleCartUpdate,"apply-discount":_vm.handleApplyDiscount}})],1)}
var CartDrawervue_type_template_id_f45abcce_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/CartDrawerHeader.vue?vue&type=template&id=09ade0dc&
var CartDrawerHeadervue_type_template_id_09ade0dc_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"global-drawer__header"},[_vm._m(0),_vm._v(" "),_c('button',{staticClass:"global-drawer__close btn--close",attrs:{"aria-label":"Close drawer"},on:{"click":_vm.closeDrawer}})])}
var CartDrawerHeadervue_type_template_id_09ade0dc_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"global-drawer__title-container"},[_c('div',{staticClass:"global-drawer__title"},[_c('h5',[_vm._v("Shopping"),_c('sub',[_vm._v("BAG")])])])])}]


;// CONCATENATED MODULE: ./src/scripts/vue/components/CartDrawerHeader.vue?vue&type=template&id=09ade0dc&

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/CartDrawerHeader.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var CartDrawerHeadervue_type_script_lang_js_ = ({
  name: 'CartDrawerHeader',
  methods: {
    closeDrawer() {
      if (window.PSTheme.Drawer) {
        window.PSTheme.Drawer.close();
      }
    }

  }
});
;// CONCATENATED MODULE: ./src/scripts/vue/components/CartDrawerHeader.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_CartDrawerHeadervue_type_script_lang_js_ = (CartDrawerHeadervue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./src/scripts/vue/components/CartDrawerHeader.vue





/* normalize component */
;
var CartDrawerHeader_component = (0,componentNormalizer/* default */.Z)(
  components_CartDrawerHeadervue_type_script_lang_js_,
  CartDrawerHeadervue_type_template_id_09ade0dc_render,
  CartDrawerHeadervue_type_template_id_09ade0dc_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CartDrawerHeader = (CartDrawerHeader_component.exports);
;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/CartDrawerContent.vue?vue&type=template&id=130f2105&
var CartDrawerContentvue_type_template_id_130f2105_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cart-drawer__content"},[_c('div',{staticClass:"cart-drawer__free-shipping-wrapper"},[(
        _vm.settings &&
        _vm.$settings.FreeShipping &&
        _vm.cart != null &&
        _vm.cart.item_count > 0
      )?_c('CartDrawerFreeShipping',{attrs:{"freeshipping":_vm.settings.free_shipping,"cartTotal":_vm.cart.total_price / 100}}):_vm._e()],1),_vm._v(" "),(!_vm.loading && _vm.cart != null && _vm.cart.item_count > 0)?_c('div',{staticClass:"cart-drawer__items-container"},[_c('div',{staticClass:"cart-drawer__items"},_vm._l((_vm.cart.items),function(item){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.hideCartItem(item)),expression:"hideCartItem(item)"}],key:item.key,staticClass:"cart-drawer__item"},[_c('a',{staticClass:"cart-drawer__item-image",attrs:{"href":item.url}},[_c('img',{attrs:{"src":_vm.$image(item.image, '150x'),"alt":item.product_title}})]),_vm._v(" "),_c('div',{staticClass:"cart-drawer__item-details"},[_c('a',{staticClass:"cart-drawer__item-header",attrs:{"href":item.url}},[_c('span',{staticClass:"cart-drawer__item-vendor"},[_vm._v(_vm._s(item.vendor))]),_vm._v(" "),_c('h4',{staticClass:"cart-drawer__item-title"},[_vm._v("\n              "+_vm._s(item.product_title)+"\n            ")]),_vm._v(" "),(!item.product_has_only_default_variant)?_c('span',{staticClass:"cart-drawer__item-variant"},[_c('span',{staticClass:"cart-drawer__item-variant-label"},[_vm._v("Size:")]),_vm._v(" "),_c('span',{staticClass:"cart-drawer__item-variant-value"},[_vm._v(_vm._s(item.variant_title))])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"cart-drawer__item-price"},[_vm._v("\n            "+_vm._s(_vm.$money(item.line_price))+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"cart-drawer__item-controls"},[_c('div',{staticClass:"cart-drawer__quantity item__quantity"},[_c('button',{staticClass:"cart-drawer__quantity-btn item__quantity-minus",attrs:{"disabled":_vm.isUpdating},on:{"click":function($event){return _vm.updateQuantity(item.key, item.quantity - 1)}}},[_vm._v("\n                -\n              ")]),_vm._v(" "),_c('input',{staticClass:"item__quantity-input cart-drawer__quantity-value",attrs:{"name":"updates[]","type":"text","pattern":"[0-9]*","min":"0","aria-label":"quantity"},domProps:{"value":item.quantity},on:{"input":function($event){return _vm.updateQuantity(item.key, $event.target.value)}}}),_vm._v(" "),_c('button',{staticClass:"cart-drawer__quantity-btn item__quantity-plus",attrs:{"disabled":_vm.isUpdating},on:{"click":function($event){return _vm.updateQuantity(item.key, item.quantity + 1)}}},[_vm._v("\n                +\n              ")])])])])])}),0),_vm._v(" "),_c('div',{staticClass:"cart-drawer__carousels"},[(_vm.enableUpsell)?_c('CartDrawerUpsellProducts',{attrs:{"products":_vm.upsellProducts,"title":_vm.upsellTitle}}):_vm._e(),_vm._v(" "),(_vm.enableCrossSell)?_c('CartDrawerCrosssellProducts',{attrs:{"products":_vm.crossSellProducts,"title":_vm.crossSellTitle}}):_vm._e()],1)]):(_vm.loading)?_c('div',{staticClass:"cart-drawer__items-container"},[_c('div',{staticClass:"cart-drawer__items cart-drawer__items--loading"},[_c('div',{staticClass:"cart-drawer__item cart-drawer__item--loading"},[_c('Loading',{attrs:{"activated":true}})],1)]),_vm._v(" "),_c('div',{staticClass:"cart-drawer__carousels"},[(_vm.enableUpsell)?_c('CartDrawerUpsellProducts',{attrs:{"products":_vm.upsellProducts,"title":_vm.upsellTitle}}):_vm._e(),_vm._v(" "),(_vm.enableCrossSell)?_c('CartDrawerCrosssellProducts',{attrs:{"products":_vm.crossSellProducts,"title":_vm.crossSellTitle}}):_vm._e()],1)]):_c('div',{staticClass:"cart-drawer__empty"},[_c('p',[_vm._v("You have no items in your bag")])])])}
var CartDrawerContentvue_type_template_id_130f2105_staticRenderFns = []


// EXTERNAL MODULE: ./src/scripts/utils/cart.js
var cart = __webpack_require__(7342);
;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/CartDrawerFreeShipping.vue?vue&type=template&id=2d5b468e&
var CartDrawerFreeShippingvue_type_template_id_2d5b468e_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cart-drawer__free-shipping"},[_c('div',{staticClass:"cart-drawer__free-shipping__text"},[_c('p',{domProps:{"textContent":_vm._s(
        _vm.percentComplete < 100
          ? ("You are $" + _vm.amountToFreeShipping + " away from FREE SHIPPING!")
          : 'Congrats, you qualify for FREE SHIPPING!'
      )}})]),_vm._v(" "),_c('div',{staticClass:"cart-drawer__free-shipping__bar",class:{ completed: _vm.percentComplete >= 100 }},[(_vm.percentComplete < 100)?_c('div',{staticClass:"cart-drawer__free-shipping__bar__progress",style:(("width: " + _vm.percentComplete + "%"))}):_vm._e()])])}
var CartDrawerFreeShippingvue_type_template_id_2d5b468e_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/CartDrawerFreeShipping.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var CartDrawerFreeShippingvue_type_script_lang_js_ = ({
  name: 'CartDrawerFreeShipping',
  props: ['freeshipping', 'cartTotal'],
  computed: {
    percentComplete() {
      return this.cartTotal / this.freeshipping.threshold * 100;
    },

    amountToFreeShipping() {
      return (this.freeshipping.threshold - this.cartTotal).toFixed(2);
    }

  }
});
;// CONCATENATED MODULE: ./src/scripts/vue/components/CartDrawerFreeShipping.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_CartDrawerFreeShippingvue_type_script_lang_js_ = (CartDrawerFreeShippingvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./src/scripts/vue/components/CartDrawerFreeShipping.vue



;


/* normalize component */

var CartDrawerFreeShipping_component = (0,componentNormalizer/* default */.Z)(
  components_CartDrawerFreeShippingvue_type_script_lang_js_,
  CartDrawerFreeShippingvue_type_template_id_2d5b468e_render,
  CartDrawerFreeShippingvue_type_template_id_2d5b468e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CartDrawerFreeShipping = (CartDrawerFreeShipping_component.exports);
;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/CartDrawerCrosssellProducts.vue?vue&type=template&id=c8795764&scoped=true&
var CartDrawerCrosssellProductsvue_type_template_id_c8795764_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.products.length > 0)?_c('div',{staticClass:"cart-drawer__products-slider"},[_c('div',{staticClass:"cart-drawer__products-slider-header"},[_c('h3',{staticClass:"cart-drawer__products-slider-title",domProps:{"textContent":_vm._s(_vm.title)}}),_vm._v(" "),_c('div',{staticClass:"cart-drawer__products-slider-arrows"},[_c('button',{staticClass:"cart-drawer__products-slider-arrow cart-drawer__products-slider-arrow--prev",attrs:{"type":"button","aria-label":"Previous slide","disabled":!_vm.canGoPrev},on:{"click":_vm.goToPrev}},[_c('svg',{attrs:{"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M11.25 4.5L6.75 9L11.25 13.5","stroke":"#111111","stroke-width":"1.17","stroke-linecap":"round","stroke-linejoin":"round"}})])]),_vm._v(" "),_c('button',{staticClass:"cart-drawer__products-slider-arrow cart-drawer__products-slider-arrow--next",attrs:{"type":"button","aria-label":"Next slide","disabled":!_vm.canGoNext},on:{"click":_vm.goToNext}},[_c('svg',{attrs:{"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M6.75 4.5L11.25 9L6.75 13.5","stroke":"#111111","stroke-width":"1.17","stroke-linecap":"round","stroke-linejoin":"round"}})])])])]),_vm._v(" "),_c('div',{staticClass:"cart-drawer__products-slider-container",class:{ 'cart-drawer__products-slider-container--at-end': _vm.isAtEnd }},[(_vm.mounted)?_c('slider',{ref:"splideSlider",attrs:{"options":_vm.sliderOptions}},_vm._l((_vm.products),function(product,index){return _c('slide',{key:((product.id) + "-" + index)},[_c('div',{staticClass:"cart-drawer__products-slider-item",on:{"click":function($event){return _vm.showCrosssellSizeModal(product)}}},[_c('div',{staticClass:"cart-drawer__products-slider-image"},[_c('div',{staticClass:"cart-drawer__products-slider-link"},[_c('img',{staticClass:"cart-drawer__products-slider-img",attrs:{"src":_vm.productImage(product),"alt":product.title}})])]),_vm._v(" "),_c('div',{staticClass:"cart-drawer__products-slider-details"},[_c('div',{staticClass:"cart-drawer__products-slider-info"},[_c('h4',{staticClass:"cart-drawer__products-slider-title"},[_c('p',{domProps:{"textContent":_vm._s(_vm.productTitle(product))}})]),_vm._v(" "),_c('p',{staticClass:"cart-drawer__products-slider-price"},[_vm._v("\n                "+_vm._s(_vm.$money(product.price))+"\n              ")])]),_vm._v(" "),_c('button',{staticClass:"cart-drawer__products-slider-button"},[_vm._v("\n              Pick Your Size\n            ")])])])])}),1):_c('div',{staticClass:"cart-drawer__products-slider-placeholder"},_vm._l((4),function(i){return _c('div',{key:i,staticClass:"cart-drawer__products-slider-item cart-drawer__products-slider-item--placeholder"},[_c('div',{staticClass:"cart-drawer__products-slider-image"},[_c('div',{staticClass:"cart-drawer__products-slider-img-placeholder"})]),_vm._v(" "),_c('div',{staticClass:"cart-drawer__products-slider-details"},[_c('div',{staticClass:"cart-drawer__products-slider-info"},[_c('div',{staticClass:"cart-drawer__products-slider-title-placeholder"}),_vm._v(" "),_c('div',{staticClass:"cart-drawer__products-slider-price-placeholder"})]),_vm._v(" "),_c('div',{staticClass:"cart-drawer__products-slider-button-placeholder"})])])}),0)],1),_vm._v(" "),_c('CrosssellProductModal',{attrs:{"product":_vm.selectedProduct,"showCrosssellProductModal":_vm.showCrosssellProductModal}})],1):_vm._e()}
var CartDrawerCrosssellProductsvue_type_template_id_c8795764_scoped_true_staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/@splidejs/vue-splide/src/js/index.js + 9 modules
var js = __webpack_require__(5493);
// EXTERNAL MODULE: ./node_modules/@splidejs/splide/dist/css/themes/splide-default.min.css
var splide_default_min = __webpack_require__(881);
;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/CrosssellProductModal.vue?vue&type=template&id=32f7d4a7&scoped=true&v-if=showCrosssellProductModal&
var CrosssellProductModalvue_type_template_id_32f7d4a7_scoped_true_v_if_showCrosssellProductModal_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"name":"crosssell-product-modal","width":"100%","height":"100%","maxWidth":1200,"maxHeight":750,"minWidth":320,"minHeight":400,"adaptive":true,"scrollable":true,"classes":"size-modal-wrapper"},on:{"before-close":_vm.onClose}},[_c('button',{staticClass:"vm--close",on:{"click":_vm.close}}),_vm._v(" "),_c('div',{staticClass:"size-modal"},[_c('div',{staticClass:"size-modal__content"},[(_vm.product)?_c('div',{staticClass:"size-modal__product"},[_c('div',{staticClass:"size-modal__product-content"},[_c('div',{staticClass:"size-modal__product-gallery"},[(_vm.product.type !== 'GIFT CARD')?_c('Gallery',{attrs:{"media":_vm.product.media,"images":_vm.product.images,"forcePagination":true}}):_c('div',{staticClass:"size-modal__product-image"},[_c('img',{staticClass:"size-modal__product-img",attrs:{"src":_vm.productImage,"alt":_vm.product.title}})])],1),_vm._v(" "),_c('div',{staticClass:"size-modal__product-details"},[_c('h3',{staticClass:"size-modal__product-title"},[_vm._v(_vm._s(_vm.product.title))]),_vm._v(" "),_c('div',{staticClass:"size-modal__product-price-section"},[_c('p',{staticClass:"size-modal__product-price"},[_c('span',{domProps:{"textContent":_vm._s(_vm.$money(_vm.price))}}),_vm._v(" "),(_vm.salePrice)?_c('s',{staticClass:"size-modal__product-price--sale",domProps:{"textContent":_vm._s(_vm.$money(_vm.salePrice))}}):_vm._e()]),_vm._v(" "),_c('Installments',{attrs:{"afterpay":true,"zip":false,"total":_vm.price}})],1),_vm._v(" "),_c('div',{staticClass:"size-modal__product-form"},[_c('ProductForm',{attrs:{"options":_vm.product.options,"variants":_vm.product.variants,"activeVariant":_vm.activeVariant,"hasDefaultVariant":_vm.hasDefaultVariant,"available":_vm.activeVariant.available},on:{"update:variant":function($event){return _vm.updateVariant($event)},"cart-success":_vm.onCartSuccess}})],1),_vm._v(" "),_c('div',{staticClass:"size-modal__full-details"},[_c('a',{attrs:{"href":("/products/" + (_vm.product.handle))}},[_vm._v("View Full Details")])])])]),_vm._v(" "),_c('div',{staticClass:"size-modal__product-footer"})]):_vm._e()])])])}
var CrosssellProductModalvue_type_template_id_32f7d4a7_scoped_true_v_if_showCrosssellProductModal_staticRenderFns = []


// EXTERNAL MODULE: ./src/scripts/vue/components/ProductForm.vue + 3 modules
var ProductForm = __webpack_require__(82);
// EXTERNAL MODULE: ./src/scripts/vue/components/Installments.vue + 5 modules
var Installments = __webpack_require__(2347);
// EXTERNAL MODULE: ./src/scripts/vue/components/Gallery.vue + 7 modules
var Gallery = __webpack_require__(6175);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/CrosssellProductModal.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var CrosssellProductModalvue_type_script_lang_js_ = ({
  name: 'CrosssellProductModal',
  components: {
    ProductForm: ProductForm/* default */.Z,
    Installments: Installments/* default */.Z,
    Gallery: Gallery/* default */.Z
  },
  props: {
    product: {
      type: Object,
      default: () => {}
    },
    showCrosssellProductModal: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      activeVariant: {},
      hasDefaultVariant: false
    };
  },

  computed: {
    price() {
      return this.activeVariant.price ? this.activeVariant.price : this.product.price;
    },

    salePrice() {
      return this.activeVariant.compare_at_price ? this.activeVariant.compare_at_price : this.product.variants[0].compare_at_price;
    },

    productImage() {
      if (!this.product) return '';

      if (this.product.featured_image) {
        return this.product.featured_image;
      }

      if (this.product.images && this.product.images.length > 0) {
        return this.product.images[0];
      }

      if (this.product.media && this.product.media.length > 0) {
        const imageMedia = this.product.media.find(media => media.media_type === 'image');
        return imageMedia ? imageMedia.src : null;
      }

      return window.PSTheme?.Settings?.NoImage || '/assets/no-image.jpg';
    },

    productDescription() {
      if (!this.product || !this.product.description) return ''; // Truncate description to a reasonable length for modal display

      const maxLength = 200;
      const description = this.product.description.replace(/<[^>]*>/g, ''); // Strip HTML tags

      return description.length > maxLength ? `${description.substring(0, maxLength)}...` : description;
    }

  },
  watch: {
    product: {
      handler(newProduct) {
        if (newProduct && newProduct.variants) {
          this.initializeVariant();
        }
      },

      immediate: true
    }
  },

  mounted() {
    // Add dynamic style when component mounts
    const style = document.createElement('style');
    style.textContent = '.size-modal-wrapper { padding: 20px !important; }';
    document.head.appendChild(style); // Initialize variant state for proper button behavior

    this.initializeVariant();
  },

  methods: {
    initializeVariant() {
      if (this.product && this.product.variants) {
        // For size modal, start with no variant selected so button shows "Pick Your Size"
        this.activeVariant = {};
        this.hasDefaultVariant = false;
      }
    },

    updateVariant(variant) {
      this.activeVariant = variant;
    },

    onCartSuccess() {
      // Close the modal when product is successfully added to cart
      this.close();
    },

    close() {
      this.$modal.hide('crosssell-product-modal');
    },

    onClose() {// Any cleanup logic when modal closes
    }

  }
});
;// CONCATENATED MODULE: ./src/scripts/vue/components/CrosssellProductModal.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_CrosssellProductModalvue_type_script_lang_js_ = (CrosssellProductModalvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/@ps-devs/shopify-webpack/node_modules/css-loader/dist/cjs.js??clonedRuleSet-5[0].rules[0].use[1]!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/CrosssellProductModal.vue?vue&type=style&index=0&lang=css&
var CrosssellProductModalvue_type_style_index_0_lang_css_ = __webpack_require__(3572);
;// CONCATENATED MODULE: ./node_modules/style-loader/dist/cjs.js!./node_modules/@ps-devs/shopify-webpack/node_modules/css-loader/dist/cjs.js??clonedRuleSet-5[0].rules[0].use[1]!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/CrosssellProductModal.vue?vue&type=style&index=0&lang=css&

      
      
      
      
      
      
      
      
      

var CrosssellProductModalvue_type_style_index_0_lang_css_options = {};

CrosssellProductModalvue_type_style_index_0_lang_css_options.styleTagTransform = (styleTagTransform_default());
CrosssellProductModalvue_type_style_index_0_lang_css_options.setAttributes = (setAttributesWithoutAttributes_default());

      CrosssellProductModalvue_type_style_index_0_lang_css_options.insert = insertBySelector_default().bind(null, "head");
    
CrosssellProductModalvue_type_style_index_0_lang_css_options.domAPI = (styleDomAPI_default());
CrosssellProductModalvue_type_style_index_0_lang_css_options.insertStyleElement = (insertStyleElement_default());

var CrosssellProductModalvue_type_style_index_0_lang_css_update = injectStylesIntoStyleTag_default()(CrosssellProductModalvue_type_style_index_0_lang_css_/* default */.Z, CrosssellProductModalvue_type_style_index_0_lang_css_options);




       /* harmony default export */ var components_CrosssellProductModalvue_type_style_index_0_lang_css_ = (CrosssellProductModalvue_type_style_index_0_lang_css_/* default */.Z && CrosssellProductModalvue_type_style_index_0_lang_css_/* default.locals */.Z.locals ? CrosssellProductModalvue_type_style_index_0_lang_css_/* default.locals */.Z.locals : undefined);

;// CONCATENATED MODULE: ./src/scripts/vue/components/CrosssellProductModal.vue?vue&type=style&index=0&lang=css&

// EXTERNAL MODULE: ./node_modules/@ps-devs/shopify-webpack/node_modules/css-loader/dist/cjs.js??clonedRuleSet-5[0].rules[0].use[1]!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/CrosssellProductModal.vue?vue&type=style&index=1&id=32f7d4a7&scoped=true&lang=css&
var CrosssellProductModalvue_type_style_index_1_id_32f7d4a7_scoped_true_lang_css_ = __webpack_require__(7766);
;// CONCATENATED MODULE: ./node_modules/style-loader/dist/cjs.js!./node_modules/@ps-devs/shopify-webpack/node_modules/css-loader/dist/cjs.js??clonedRuleSet-5[0].rules[0].use[1]!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/CrosssellProductModal.vue?vue&type=style&index=1&id=32f7d4a7&scoped=true&lang=css&

      
      
      
      
      
      
      
      
      

var CrosssellProductModalvue_type_style_index_1_id_32f7d4a7_scoped_true_lang_css_options = {};

CrosssellProductModalvue_type_style_index_1_id_32f7d4a7_scoped_true_lang_css_options.styleTagTransform = (styleTagTransform_default());
CrosssellProductModalvue_type_style_index_1_id_32f7d4a7_scoped_true_lang_css_options.setAttributes = (setAttributesWithoutAttributes_default());

      CrosssellProductModalvue_type_style_index_1_id_32f7d4a7_scoped_true_lang_css_options.insert = insertBySelector_default().bind(null, "head");
    
CrosssellProductModalvue_type_style_index_1_id_32f7d4a7_scoped_true_lang_css_options.domAPI = (styleDomAPI_default());
CrosssellProductModalvue_type_style_index_1_id_32f7d4a7_scoped_true_lang_css_options.insertStyleElement = (insertStyleElement_default());

var CrosssellProductModalvue_type_style_index_1_id_32f7d4a7_scoped_true_lang_css_update = injectStylesIntoStyleTag_default()(CrosssellProductModalvue_type_style_index_1_id_32f7d4a7_scoped_true_lang_css_/* default */.Z, CrosssellProductModalvue_type_style_index_1_id_32f7d4a7_scoped_true_lang_css_options);




       /* harmony default export */ var components_CrosssellProductModalvue_type_style_index_1_id_32f7d4a7_scoped_true_lang_css_ = (CrosssellProductModalvue_type_style_index_1_id_32f7d4a7_scoped_true_lang_css_/* default */.Z && CrosssellProductModalvue_type_style_index_1_id_32f7d4a7_scoped_true_lang_css_/* default.locals */.Z.locals ? CrosssellProductModalvue_type_style_index_1_id_32f7d4a7_scoped_true_lang_css_/* default.locals */.Z.locals : undefined);

;// CONCATENATED MODULE: ./src/scripts/vue/components/CrosssellProductModal.vue?vue&type=style&index=1&id=32f7d4a7&scoped=true&lang=css&

;// CONCATENATED MODULE: ./src/scripts/vue/components/CrosssellProductModal.vue



;



/* normalize component */

var CrosssellProductModal_component = (0,componentNormalizer/* default */.Z)(
  components_CrosssellProductModalvue_type_script_lang_js_,
  CrosssellProductModalvue_type_template_id_32f7d4a7_scoped_true_v_if_showCrosssellProductModal_render,
  CrosssellProductModalvue_type_template_id_32f7d4a7_scoped_true_v_if_showCrosssellProductModal_staticRenderFns,
  false,
  null,
  "32f7d4a7",
  null
  
)

/* harmony default export */ var CrosssellProductModal = (CrosssellProductModal_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/CartDrawerCrosssellProducts.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
 // eslint-disable-next-line import/no-extraneous-dependencies



/* harmony default export */ var CartDrawerCrosssellProductsvue_type_script_lang_js_ = ({
  name: 'CartDrawerCrosssellProducts',
  components: {
    slider: js/* Splide */.tv,
    slide: js/* SplideSlide */.jw,
    CrosssellProductModal: CrosssellProductModal
  },
  props: {
    products: {
      type: Array,
      required: false,
      default: () => []
    },
    title: {
      type: String,
      required: false,
      default: 'Products'
    }
  },

  data() {
    return {
      mounted: false,
      splideInstance: null,
      canGoPrev: false,
      canGoNext: true,
      selectedProduct: null,
      showCrosssellProductModal: false,
      sliderOptions: {
        perPage: 1.7,
        arrows: false,
        // Disable default arrows since we have custom arrows
        pagination: false,
        gap: '10px',
        drag: true,
        snap: false,
        focus: 'end',
        // Ensure the last slide is fully visible when we reach the end
        breakpoints: {
          768: {
            perPage: 1.7
          },
          480: {
            perPage: 1.7
          }
        }
      }
    };
  },

  computed: {
    isAtEnd() {
      if (this.splideInstance) {
        const {
          index,
          length
        } = this.splideInstance;
        return index === length - 1;
      }

      return false;
    }

  },

  mounted() {
    this.mounted = true;
    this.$nextTick(() => {
      this.initializeSplide();
    });
  },

  beforeDestroy() {
    if (this.splideInstance) {
      this.splideInstance.off('moved', this.updateArrowStates);
      this.splideInstance.off('mounted', this.updateArrowStates);
    }
  },

  methods: {
    initializeSplide() {
      if (this.$refs.splideSlider && this.$refs.splideSlider.splide) {
        this.splideInstance = this.$refs.splideSlider.splide; // Listen to Splide events

        this.splideInstance.on('moved', this.updateArrowStates);
        this.splideInstance.on('mounted', this.updateArrowStates); // Initial state update

        this.updateArrowStates();
      }
    },

    updateArrowStates() {
      if (this.splideInstance) {
        const {
          index,
          length
        } = this.splideInstance;
        this.canGoPrev = index > 0; // For perPage: 1.7, we're at the end when we're at the last slide
        // (which will show the full last slide with focus: 'end')

        this.canGoNext = index < length - 1;
      }
    },

    goToNext() {
      if (this.splideInstance && this.canGoNext) {
        const currentIndex = this.splideInstance.index;
        const totalSlides = this.splideInstance.length; // If we're near the end, go to the last slide to show it fully

        if (currentIndex >= totalSlides - 2) {
          this.splideInstance.go(totalSlides - 1);
        } else {
          this.splideInstance.go(currentIndex + 1);
        }
      }
    },

    goToPrev() {
      if (this.splideInstance && this.canGoPrev) {
        const currentIndex = this.splideInstance.index;
        this.splideInstance.go(currentIndex - 1);
      }
    },

    productUrl(product) {
      return `/products/${product.handle}`;
    },

    productImage(product) {
      if (product.featured_image) {
        return product.featured_image;
      }

      if (product.images && product.images.length > 0) {
        return product.images[0];
      }

      if (product.media && product.media.length > 0) {
        const imageMedia = product.media.find(media => media.media_type === 'image');
        return imageMedia ? imageMedia.src : null;
      }

      return window.PSTheme?.Settings?.NoImage || '/assets/no-image.jpg';
    },

    productTitle(product) {
      return product.title;
    },

    showCrosssellSizeModal(product) {
      this.selectedProduct = product;
      this.showCrosssellProductModal = true;
      this.$modal.show('crosssell-product-modal');
    }

  }
});
;// CONCATENATED MODULE: ./src/scripts/vue/components/CartDrawerCrosssellProducts.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_CartDrawerCrosssellProductsvue_type_script_lang_js_ = (CartDrawerCrosssellProductsvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./src/scripts/vue/components/CartDrawerCrosssellProducts.vue



;


/* normalize component */

var CartDrawerCrosssellProducts_component = (0,componentNormalizer/* default */.Z)(
  components_CartDrawerCrosssellProductsvue_type_script_lang_js_,
  CartDrawerCrosssellProductsvue_type_template_id_c8795764_scoped_true_render,
  CartDrawerCrosssellProductsvue_type_template_id_c8795764_scoped_true_staticRenderFns,
  false,
  null,
  "c8795764",
  null
  
)

/* harmony default export */ var CartDrawerCrosssellProducts = (CartDrawerCrosssellProducts_component.exports);
;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/CartDrawerUpsellProducts.vue?vue&type=template&id=ee21e302&scoped=true&
var CartDrawerUpsellProductsvue_type_template_id_ee21e302_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.products.length > 0)?_c('div',{staticClass:"cart-drawer__products-slider"},[_c('div',{staticClass:"cart-drawer__products-slider-header"},[_c('h3',{staticClass:"cart-drawer__products-slider-title",domProps:{"textContent":_vm._s(_vm.title)}}),_vm._v(" "),_c('div',{staticClass:"cart-drawer__products-slider-arrows"},[_c('button',{staticClass:"cart-drawer__products-slider-arrow cart-drawer__products-slider-arrow--prev",attrs:{"type":"button","aria-label":"Previous slide","disabled":!_vm.canGoPrev},on:{"click":_vm.goToPrev}},[_c('svg',{attrs:{"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M11.25 4.5L6.75 9L11.25 13.5","stroke":"#111111","stroke-width":"1.17","stroke-linecap":"round","stroke-linejoin":"round"}})])]),_vm._v(" "),_c('button',{staticClass:"cart-drawer__products-slider-arrow cart-drawer__products-slider-arrow--next",attrs:{"type":"button","aria-label":"Next slide","disabled":!_vm.canGoNext},on:{"click":_vm.goToNext}},[_c('svg',{attrs:{"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M6.75 4.5L11.25 9L6.75 13.5","stroke":"#111111","stroke-width":"1.17","stroke-linecap":"round","stroke-linejoin":"round"}})])])])]),_vm._v(" "),_c('div',{staticClass:"cart-drawer__products-slider-container",class:{ 'cart-drawer__products-slider-container--at-end': _vm.isAtEnd }},[(_vm.mounted)?_c('slider',{ref:"splideSlider",attrs:{"options":_vm.sliderOptions}},_vm._l((_vm.products),function(product,index){return _c('slide',{key:((product.id) + "-" + index)},[_c('div',{staticClass:"cart-drawer__products-slider-item",on:{"click":function($event){return _vm.showUpsellSizeModal(product)}}},[_c('div',{staticClass:"cart-drawer__products-slider-image"},[_c('div',{staticClass:"cart-drawer__products-slider-link"},[_c('img',{staticClass:"cart-drawer__products-slider-img",attrs:{"src":_vm.productImage(product),"alt":product.title}})])]),_vm._v(" "),_c('div',{staticClass:"cart-drawer__products-slider-details"},[_c('div',{staticClass:"cart-drawer__products-slider-info"},[_c('h4',{staticClass:"cart-drawer__products-slider-title"},[_c('p',{domProps:{"textContent":_vm._s(_vm.productTitle(product))}})]),_vm._v(" "),_c('p',{staticClass:"cart-drawer__products-slider-price"},[_vm._v("\n                "+_vm._s(_vm.$money(product.price))+"\n              ")])]),_vm._v(" "),_c('button',{staticClass:"cart-drawer__products-slider-button"},[_vm._v("\n              Pick Your Size\n            ")])])])])}),1):_c('div',{staticClass:"cart-drawer__products-slider-placeholder"},_vm._l((4),function(i){return _c('div',{key:i,staticClass:"cart-drawer__products-slider-item cart-drawer__products-slider-item--placeholder"},[_c('div',{staticClass:"cart-drawer__products-slider-image"},[_c('div',{staticClass:"cart-drawer__products-slider-img-placeholder"})]),_vm._v(" "),_c('div',{staticClass:"cart-drawer__products-slider-details"},[_c('div',{staticClass:"cart-drawer__products-slider-info"},[_c('div',{staticClass:"cart-drawer__products-slider-title-placeholder"}),_vm._v(" "),_c('div',{staticClass:"cart-drawer__products-slider-price-placeholder"})]),_vm._v(" "),_c('div',{staticClass:"cart-drawer__products-slider-button-placeholder"})])])}),0)],1),_vm._v(" "),_c('UpsellProductModal',{attrs:{"product":_vm.selectedProduct,"showUpsellProductModal":_vm.showUpsellProductModal}})],1):_vm._e()}
var CartDrawerUpsellProductsvue_type_template_id_ee21e302_scoped_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/UpsellProductModal.vue?vue&type=template&id=7413fe77&scoped=true&v-if=showUpsellProductModal&
var UpsellProductModalvue_type_template_id_7413fe77_scoped_true_v_if_showUpsellProductModal_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"name":"upsell-product-modal","width":"100%","height":"100%","maxWidth":1200,"maxHeight":750,"minWidth":320,"minHeight":400,"adaptive":true,"scrollable":true,"classes":"size-modal-wrapper"},on:{"before-close":_vm.onClose}},[_c('button',{staticClass:"vm--close",on:{"click":_vm.close}}),_vm._v(" "),_c('div',{staticClass:"size-modal"},[_c('div',{staticClass:"size-modal__content"},[(_vm.product)?_c('div',{staticClass:"size-modal__product"},[_c('div',{staticClass:"size-modal__product-content"},[_c('div',{staticClass:"size-modal__product-gallery"},[(_vm.product.type !== 'GIFT CARD')?_c('Gallery',{attrs:{"media":_vm.product.media,"images":_vm.product.images,"forcePagination":true}}):_c('div',{staticClass:"size-modal__product-image"},[_c('img',{staticClass:"size-modal__product-img",attrs:{"src":_vm.productImage,"alt":_vm.product.title}})])],1),_vm._v(" "),_c('div',{staticClass:"size-modal__product-details"},[_c('h3',{staticClass:"size-modal__product-title"},[_vm._v(_vm._s(_vm.product.title))]),_vm._v(" "),_c('div',{staticClass:"size-modal__product-price-section"},[_c('p',{staticClass:"size-modal__product-price"},[_c('span',{domProps:{"textContent":_vm._s(_vm.$money(_vm.price))}}),_vm._v(" "),(_vm.salePrice)?_c('s',{staticClass:"size-modal__product-price--sale",domProps:{"textContent":_vm._s(_vm.$money(_vm.salePrice))}}):_vm._e()]),_vm._v(" "),_c('Installments',{attrs:{"afterpay":true,"zip":false,"total":_vm.price}})],1),_vm._v(" "),_c('div',{staticClass:"size-modal__product-form"},[_c('ProductForm',{attrs:{"options":_vm.product.options,"variants":_vm.product.variants,"activeVariant":_vm.activeVariant,"hasDefaultVariant":_vm.hasDefaultVariant,"available":_vm.activeVariant.available},on:{"update:variant":function($event){return _vm.updateVariant($event)},"cart-success":_vm.onCartSuccess}})],1),_vm._v(" "),_c('div',{staticClass:"size-modal__full-details"},[_c('a',{attrs:{"href":("/products/" + (_vm.product.handle))}},[_vm._v("View Full Details")])])])]),_vm._v(" "),_c('div',{staticClass:"size-modal__product-footer"})]):_vm._e()])])])}
var UpsellProductModalvue_type_template_id_7413fe77_scoped_true_v_if_showUpsellProductModal_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/UpsellProductModal.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var UpsellProductModalvue_type_script_lang_js_ = ({
  name: 'UpsellProductModal',
  components: {
    ProductForm: ProductForm/* default */.Z,
    Installments: Installments/* default */.Z,
    Gallery: Gallery/* default */.Z
  },
  props: {
    product: {
      type: Object,
      default: () => {}
    },
    showUpsellProductModal: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      activeVariant: {},
      hasDefaultVariant: false
    };
  },

  computed: {
    price() {
      return this.activeVariant.price ? this.activeVariant.price : this.product.price;
    },

    salePrice() {
      return this.activeVariant.compare_at_price ? this.activeVariant.compare_at_price : this.product.variants[0].compare_at_price;
    },

    productImage() {
      if (!this.product) return '';

      if (this.product.featured_image) {
        return this.product.featured_image;
      }

      if (this.product.images && this.product.images.length > 0) {
        return this.product.images[0];
      }

      if (this.product.media && this.product.media.length > 0) {
        const imageMedia = this.product.media.find(media => media.media_type === 'image');
        return imageMedia ? imageMedia.src : null;
      }

      return window.PSTheme?.Settings?.NoImage || '/assets/no-image.jpg';
    },

    productDescription() {
      if (!this.product || !this.product.description) return ''; // Truncate description to a reasonable length for modal display

      const maxLength = 200;
      const description = this.product.description.replace(/<[^>]*>/g, ''); // Strip HTML tags

      return description.length > maxLength ? `${description.substring(0, maxLength)}...` : description;
    }

  },
  watch: {
    product: {
      handler(newProduct) {
        if (newProduct && newProduct.variants) {
          this.initializeVariant();
        }
      },

      immediate: true
    }
  },

  mounted() {
    // Add dynamic style when component mounts
    const style = document.createElement('style');
    style.textContent = '.size-modal-wrapper { padding: 20px !important; }';
    document.head.appendChild(style); // Initialize variant state for proper button behavior

    this.initializeVariant();
  },

  methods: {
    initializeVariant() {
      if (this.product && this.product.variants) {
        // For size modal, start with no variant selected so button shows "Pick Your Size"
        this.activeVariant = {};
        this.hasDefaultVariant = false;
      }
    },

    updateVariant(variant) {
      this.activeVariant = variant;
    },

    onCartSuccess() {
      // Close the modal when product is successfully added to cart
      this.close();
    },

    close() {
      this.$modal.hide('upsell-product-modal');
    },

    onClose() {// Any cleanup logic when modal closes
    }

  }
});
;// CONCATENATED MODULE: ./src/scripts/vue/components/UpsellProductModal.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_UpsellProductModalvue_type_script_lang_js_ = (UpsellProductModalvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/@ps-devs/shopify-webpack/node_modules/css-loader/dist/cjs.js??clonedRuleSet-5[0].rules[0].use[1]!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/UpsellProductModal.vue?vue&type=style&index=0&lang=css&
var UpsellProductModalvue_type_style_index_0_lang_css_ = __webpack_require__(4453);
;// CONCATENATED MODULE: ./node_modules/style-loader/dist/cjs.js!./node_modules/@ps-devs/shopify-webpack/node_modules/css-loader/dist/cjs.js??clonedRuleSet-5[0].rules[0].use[1]!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/UpsellProductModal.vue?vue&type=style&index=0&lang=css&

      
      
      
      
      
      
      
      
      

var UpsellProductModalvue_type_style_index_0_lang_css_options = {};

UpsellProductModalvue_type_style_index_0_lang_css_options.styleTagTransform = (styleTagTransform_default());
UpsellProductModalvue_type_style_index_0_lang_css_options.setAttributes = (setAttributesWithoutAttributes_default());

      UpsellProductModalvue_type_style_index_0_lang_css_options.insert = insertBySelector_default().bind(null, "head");
    
UpsellProductModalvue_type_style_index_0_lang_css_options.domAPI = (styleDomAPI_default());
UpsellProductModalvue_type_style_index_0_lang_css_options.insertStyleElement = (insertStyleElement_default());

var UpsellProductModalvue_type_style_index_0_lang_css_update = injectStylesIntoStyleTag_default()(UpsellProductModalvue_type_style_index_0_lang_css_/* default */.Z, UpsellProductModalvue_type_style_index_0_lang_css_options);




       /* harmony default export */ var components_UpsellProductModalvue_type_style_index_0_lang_css_ = (UpsellProductModalvue_type_style_index_0_lang_css_/* default */.Z && UpsellProductModalvue_type_style_index_0_lang_css_/* default.locals */.Z.locals ? UpsellProductModalvue_type_style_index_0_lang_css_/* default.locals */.Z.locals : undefined);

;// CONCATENATED MODULE: ./src/scripts/vue/components/UpsellProductModal.vue?vue&type=style&index=0&lang=css&

// EXTERNAL MODULE: ./node_modules/@ps-devs/shopify-webpack/node_modules/css-loader/dist/cjs.js??clonedRuleSet-5[0].rules[0].use[1]!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/UpsellProductModal.vue?vue&type=style&index=1&id=7413fe77&scoped=true&lang=css&
var UpsellProductModalvue_type_style_index_1_id_7413fe77_scoped_true_lang_css_ = __webpack_require__(7744);
;// CONCATENATED MODULE: ./node_modules/style-loader/dist/cjs.js!./node_modules/@ps-devs/shopify-webpack/node_modules/css-loader/dist/cjs.js??clonedRuleSet-5[0].rules[0].use[1]!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/UpsellProductModal.vue?vue&type=style&index=1&id=7413fe77&scoped=true&lang=css&

      
      
      
      
      
      
      
      
      

var UpsellProductModalvue_type_style_index_1_id_7413fe77_scoped_true_lang_css_options = {};

UpsellProductModalvue_type_style_index_1_id_7413fe77_scoped_true_lang_css_options.styleTagTransform = (styleTagTransform_default());
UpsellProductModalvue_type_style_index_1_id_7413fe77_scoped_true_lang_css_options.setAttributes = (setAttributesWithoutAttributes_default());

      UpsellProductModalvue_type_style_index_1_id_7413fe77_scoped_true_lang_css_options.insert = insertBySelector_default().bind(null, "head");
    
UpsellProductModalvue_type_style_index_1_id_7413fe77_scoped_true_lang_css_options.domAPI = (styleDomAPI_default());
UpsellProductModalvue_type_style_index_1_id_7413fe77_scoped_true_lang_css_options.insertStyleElement = (insertStyleElement_default());

var UpsellProductModalvue_type_style_index_1_id_7413fe77_scoped_true_lang_css_update = injectStylesIntoStyleTag_default()(UpsellProductModalvue_type_style_index_1_id_7413fe77_scoped_true_lang_css_/* default */.Z, UpsellProductModalvue_type_style_index_1_id_7413fe77_scoped_true_lang_css_options);




       /* harmony default export */ var components_UpsellProductModalvue_type_style_index_1_id_7413fe77_scoped_true_lang_css_ = (UpsellProductModalvue_type_style_index_1_id_7413fe77_scoped_true_lang_css_/* default */.Z && UpsellProductModalvue_type_style_index_1_id_7413fe77_scoped_true_lang_css_/* default.locals */.Z.locals ? UpsellProductModalvue_type_style_index_1_id_7413fe77_scoped_true_lang_css_/* default.locals */.Z.locals : undefined);

;// CONCATENATED MODULE: ./src/scripts/vue/components/UpsellProductModal.vue?vue&type=style&index=1&id=7413fe77&scoped=true&lang=css&

;// CONCATENATED MODULE: ./src/scripts/vue/components/UpsellProductModal.vue



;



/* normalize component */

var UpsellProductModal_component = (0,componentNormalizer/* default */.Z)(
  components_UpsellProductModalvue_type_script_lang_js_,
  UpsellProductModalvue_type_template_id_7413fe77_scoped_true_v_if_showUpsellProductModal_render,
  UpsellProductModalvue_type_template_id_7413fe77_scoped_true_v_if_showUpsellProductModal_staticRenderFns,
  false,
  null,
  "7413fe77",
  null
  
)

/* harmony default export */ var UpsellProductModal = (UpsellProductModal_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/CartDrawerUpsellProducts.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
 // eslint-disable-next-line import/no-extraneous-dependencies



/* harmony default export */ var CartDrawerUpsellProductsvue_type_script_lang_js_ = ({
  name: 'CartDrawerUpsellProducts',
  components: {
    slider: js/* Splide */.tv,
    slide: js/* SplideSlide */.jw,
    UpsellProductModal: UpsellProductModal
  },
  props: {
    products: {
      type: Array,
      required: false,
      default: () => []
    },
    title: {
      type: String,
      required: false,
      default: 'Products'
    }
  },

  data() {
    return {
      mounted: false,
      splideInstance: null,
      canGoPrev: false,
      canGoNext: true,
      selectedProduct: null,
      showUpsellProductModal: false,
      sliderOptions: {
        perPage: 1.7,
        arrows: false,
        // Disable default arrows since we have custom arrows
        pagination: false,
        gap: '10px',
        drag: true,
        snap: false,
        focus: 'end',
        // Ensure the last slide is fully visible when we reach the end
        breakpoints: {
          768: {
            perPage: 1.7
          },
          480: {
            perPage: 1.7
          }
        }
      }
    };
  },

  computed: {
    isAtEnd() {
      if (this.splideInstance) {
        const {
          index,
          length
        } = this.splideInstance;
        return index === length - 1;
      }

      return false;
    }

  },

  mounted() {
    this.mounted = true;
    this.$nextTick(() => {
      this.initializeSplide();
    });
  },

  beforeDestroy() {
    if (this.splideInstance) {
      this.splideInstance.off('moved', this.updateArrowStates);
      this.splideInstance.off('mounted', this.updateArrowStates);
    }
  },

  methods: {
    initializeSplide() {
      if (this.$refs.splideSlider && this.$refs.splideSlider.splide) {
        this.splideInstance = this.$refs.splideSlider.splide; // Listen to Splide events

        this.splideInstance.on('moved', this.updateArrowStates);
        this.splideInstance.on('mounted', this.updateArrowStates); // Initial state update

        this.updateArrowStates();
      }
    },

    updateArrowStates() {
      if (this.splideInstance) {
        const {
          index,
          length
        } = this.splideInstance;
        this.canGoPrev = index > 0; // For perPage: 1.7, we're at the end when we're at the last slide
        // (which will show the full last slide with focus: 'end')

        this.canGoNext = index < length - 1;
      }
    },

    goToNext() {
      if (this.splideInstance && this.canGoNext) {
        const currentIndex = this.splideInstance.index;
        const totalSlides = this.splideInstance.length; // If we're near the end, go to the last slide to show it fully

        if (currentIndex >= totalSlides - 2) {
          this.splideInstance.go(totalSlides - 1);
        } else {
          this.splideInstance.go(currentIndex + 1);
        }
      }
    },

    goToPrev() {
      if (this.splideInstance && this.canGoPrev) {
        const currentIndex = this.splideInstance.index;
        this.splideInstance.go(currentIndex - 1);
      }
    },

    productUrl(product) {
      return `/products/${product.handle}`;
    },

    productImage(product) {
      if (product.featured_image) {
        return product.featured_image;
      }

      if (product.images && product.images.length > 0) {
        return product.images[0];
      }

      if (product.media && product.media.length > 0) {
        const imageMedia = product.media.find(media => media.media_type === 'image');
        return imageMedia ? imageMedia.src : null;
      }

      return window.PSTheme?.Settings?.NoImage || '/assets/no-image.jpg';
    },

    productTitle(product) {
      return product.title;
    },

    showUpsellSizeModal(product) {
      this.selectedProduct = product;
      this.showUpsellProductModal = true;
      this.$modal.show('upsell-product-modal');
    }

  }
});
;// CONCATENATED MODULE: ./src/scripts/vue/components/CartDrawerUpsellProducts.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_CartDrawerUpsellProductsvue_type_script_lang_js_ = (CartDrawerUpsellProductsvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./src/scripts/vue/components/CartDrawerUpsellProducts.vue



;


/* normalize component */

var CartDrawerUpsellProducts_component = (0,componentNormalizer/* default */.Z)(
  components_CartDrawerUpsellProductsvue_type_script_lang_js_,
  CartDrawerUpsellProductsvue_type_template_id_ee21e302_scoped_true_render,
  CartDrawerUpsellProductsvue_type_template_id_ee21e302_scoped_true_staticRenderFns,
  false,
  null,
  "ee21e302",
  null
  
)

/* harmony default export */ var CartDrawerUpsellProducts = (CartDrawerUpsellProducts_component.exports);
// EXTERNAL MODULE: ./src/scripts/vue/components/Loading.vue + 4 modules
var Loading = __webpack_require__(9918);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/CartDrawerContent.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var CartDrawerContentvue_type_script_lang_js_ = ({
  components: {
    CartDrawerFreeShipping: CartDrawerFreeShipping,
    CartDrawerCrosssellProducts: CartDrawerCrosssellProducts,
    CartDrawerUpsellProducts: CartDrawerUpsellProducts,
    Loading: Loading/* default */.Z
  },
  props: {
    cart: {
      type: Object,
      required: true
    },
    enableUpsell: {
      type: Boolean,
      required: false,
      default: false
    },
    enableCrossSell: {
      type: Boolean,
      required: false,
      default: false
    },
    upsellProducts: {
      type: Array,
      required: false,
      default: () => []
    },
    upsellTitle: {
      type: String,
      required: false,
      default: ''
    },
    crossSellProducts: {
      type: Array,
      required: false,
      default: () => []
    },
    crossSellTitle: {
      type: String,
      required: false,
      default: ''
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data() {
    return {
      isUpdating: false,
      settings: null
    };
  },

  mounted() {
    this.loadSettings();
  },

  methods: {
    loadSettings() {
      fetch('/collections/all?view=cart').then(res => res.json()).then(settings => {
        if (settings.length) {
          this.settings = JSON.parse(settings);
        }
      });
    },

    updateQuantity(key, qty) {
      this.isUpdating = true;
      (0,cart/* updateItem */.$G)(key, {
        quantity: qty
      }).then(state => {
        this.$emit('cart-updated', state); // Update header cart count

        if (window.PSTheme.Vue.Header) {
          window.PSTheme.Vue.Header.setCartCount(state.item_count);
        }

        this.isUpdating = false;
      }).catch(() => {
        this.isUpdating = false;
      });
    },

    hideCartItem(line) {
      if (line.properties) {
        return !line.properties._hide;
      }

      return true;
    },

    closeDrawer() {
      if (window.PSTheme.Drawer) {
        window.PSTheme.Drawer.close();
      }
    }

  }
});
;// CONCATENATED MODULE: ./src/scripts/vue/components/CartDrawerContent.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_CartDrawerContentvue_type_script_lang_js_ = (CartDrawerContentvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./src/scripts/vue/components/CartDrawerContent.vue





/* normalize component */
;
var CartDrawerContent_component = (0,componentNormalizer/* default */.Z)(
  components_CartDrawerContentvue_type_script_lang_js_,
  CartDrawerContentvue_type_template_id_130f2105_render,
  CartDrawerContentvue_type_template_id_130f2105_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CartDrawerContent = (CartDrawerContent_component.exports);
;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/CartDrawerFooter.vue?vue&type=template&id=c4791b02&
var CartDrawerFootervue_type_template_id_c4791b02_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cart-drawer__footer"},[(_vm.cart && _vm.cart.item_count > 0)?_c('div',{staticClass:"cart-drawer__footer-container"},[_c('div',{staticClass:"cart-drawer__discount"},[_c('h5',{staticClass:"cart-drawer__discount-title"},[_vm._v("Got a discount code?")]),_vm._v(" "),_c('div',{staticClass:"cart-drawer__discount-container"},[_c('div',{staticClass:"cart-drawer__discount-form"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.discount),expression:"discount"}],staticClass:"cart-drawer__discount-input",attrs:{"name":"discount","type":"text","aria-label":"discount","disabled":_vm.isApplyingDiscount,"placeholder":"Enter code"},domProps:{"value":(_vm.discount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.discount=$event.target.value}}}),_vm._v(" "),_c('svg',{staticClass:"cart-drawer__discount-icon",class:{ hidden: !_vm.discountSuccess },attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M0 9.75C0 4.36522 4.36522 0 9.75 0C15.1348 0 19.5 4.36522 19.5 9.75C19.5 15.1348 15.1348 19.5 9.75 19.5C4.36522 19.5 0 15.1348 0 9.75ZM13.3603 7.93593C13.6011 7.59887 13.523 7.13046 13.1859 6.8897C12.8489 6.64894 12.3805 6.72701 12.1397 7.06407L8.9043 11.5936L7.28033 9.96967C6.98744 9.67678 6.51256 9.67678 6.21967 9.96967C5.92678 10.2626 5.92678 10.7374 6.21967 11.0303L8.46967 13.2803C8.62556 13.4362 8.84215 13.5156 9.06186 13.4974C9.28157 13.4793 9.48216 13.3653 9.6103 13.1859L13.3603 7.93593Z","fill":"#78A673"}})]),_vm._v(" "),_c('button',{staticClass:"btn cart-drawer__discount-button",class:_vm.discount !== '' ? 'cart-drawer__discount-button--active' : '',attrs:{"disabled":_vm.isApplyingDiscount || _vm.discount === ''},on:{"click":_vm.applyDiscount}},[_vm._v("\n            Apply\n          ")])])]),_vm._v(" "),(_vm.discountError)?_c('div',{staticClass:"cart-drawer__discount-error"},[_vm._v("\n        "+_vm._s(_vm.discountMessage)+"\n      ")]):_vm._e(),_vm._v(" "),(_vm.discountSuccess)?_c('div',{staticClass:"cart-drawer__discount-success"},[_vm._v("\n        "+_vm._s(_vm.discountMessage)+"\n      ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"cart-drawer__total"},[_c('span',{staticClass:"cart-drawer__total-label"},[_vm._v("Subtotal:")]),_vm._v(" "),_c('span',{staticClass:"cart-drawer__total-value"},[_vm._v(_vm._s(_vm.$money(_vm.cartTotal)))])]),_vm._v(" "),_c('div',{staticClass:"cart-drawer__actions"},[_c('button',{staticClass:"btn btn--primary",on:{"click":_vm.checkout}},[_vm._v("Checkout")])])]):_c('div',{staticClass:"cart-drawer__footer-container"},[_c('a',{staticClass:"cart-drawer__continue-shopping",attrs:{"href":"/"},on:{"click":_vm.continueShopping}},[_vm._v("\n      Continue Shopping\n    ")])])])}
var CartDrawerFootervue_type_template_id_c4791b02_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/CartDrawerFooter.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var CartDrawerFootervue_type_script_lang_js_ = ({
  name: 'CartDrawerFooter',
  props: {
    cart: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      discount: '',
      isApplyingDiscount: false,
      discountError: false,
      discountSuccess: false,
      discountMessage: '',
      discountType: '',
      discountValue: ''
    };
  },

  computed: {
    cartTotal() {
      return this.cart.total_price;
    }

  },

  mounted() {
    // Check for existing discount codes when component mounts
    if (this.cart) {
      this.processExistingDiscountCodes(this.cart);
    }
  },

  methods: {
    checkout() {
      window.location.href = '/checkout';
    },

    continueShopping(e) {
      e.preventDefault();
      window.location.href = '/';
    },

    resetDiscountStates() {
      this.discountError = false;
      this.discountSuccess = false;
      this.discountMessage = '';
      this.discountType = '';
      this.discountValue = '';
    },

    processDiscountCodes(cart) {
      if (!cart || !cart.discount_codes || cart.discount_codes.length === 0) {
        return;
      }

      const discountCode = cart.discount_codes[0];

      if (discountCode.applicable) {
        // Discount code is applicable
        this.discountSuccess = true;
        this.discount = discountCode.code; // Extract discount details from cart_level_discount_applications

        if (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length > 0) {
          const discountApplication = cart.cart_level_discount_applications[0];
          let discountData = null;

          if (discountApplication.discount_application) {
            discountData = discountApplication.discount_application;
          } else if (discountApplication.value_type && discountApplication.value) {
            discountData = discountApplication;
          }

          if (discountData) {
            this.discountType = discountData.value_type;
            this.discountValue = discountData.value; // Update message based on discount type

            this.updateDiscountMessage();
          } else {
            // Fallback if structure is different
            this.discountMessage = `${discountCode.code} applied!`;
          }
        } else {
          // Discount applied but no cart_level_discount_applications data
          this.discountMessage = `${discountCode.code} applied!`;
        }
      } else {
        // Discount code is not applicable - show error message
        this.discountError = true;
        this.discountMessage = 'Invalid code. Please try again.';
        this.discount = discountCode.code;
      }
    },

    processExistingDiscountCodes(cart) {
      if (!cart) {
        return;
      }

      if (cart.discount_codes && cart.discount_codes.length > 0) {
        const discountCode = cart.discount_codes[0];

        if (discountCode.applicable) {
          this.discountSuccess = true;
          this.discount = discountCode.code; // Extract discount details from cart_level_discount_applications

          if (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length > 0) {
            const discountApplication = cart.cart_level_discount_applications[0];
            let discountData = null;

            if (discountApplication.discount_application) {
              discountData = discountApplication.discount_application;
            } else if (discountApplication.value_type && discountApplication.value) {
              discountData = discountApplication;
            }

            if (discountData) {
              this.discountType = discountData.value_type;
              this.discountValue = discountData.value; // Update message based on discount type

              this.updateDiscountMessage();
            } else {
              // Fallback if structure is different
              this.discountMessage = `${discountCode.code} applied!`;
            }
          } else {
            // Discount applied but no cart_level_discount_applications data
            this.discountMessage = `${discountCode.code} applied!`;
          }
        }
      }
    },

    updateDiscountMessage() {
      if (this.discountType === 'percentage') {
        this.discountMessage = `Code applied - ${Number(this.discountValue).toFixed(0)}% off!`;
      } else if (this.discountType === 'fixed_amount') {
        this.discountMessage = `Code applied - $${Number(this.discountValue).toFixed(2)} off!`;
      }
    },

    updateDiscount(value) {
      this.discount = value; // Clear any previous messages when user types

      if (this.discountError || this.discountSuccess) {
        this.resetDiscountStates();
      }
    },

    async applyDiscount() {
      if (this.discount === '') {
        this.discountError = true;
        this.discountMessage = 'Please enter a discount code';
        return;
      }

      this.isApplyingDiscount = true;
      this.resetDiscountStates();

      try {
        // Use Shopify's Cart API to apply discount
        const updatedCart = await (0,cart/* updateCart */.xu)({
          discount: this.discount
        }); // Emit the updated cart to parent components

        this.$emit('cart-updated', updatedCart); // Check if discount_codes exists and has items

        if (updatedCart.discount_codes && updatedCart.discount_codes.length > 0) {
          this.processDiscountCodes(updatedCart);
        } else {
          // No discount codes returned, assume success
          this.discountSuccess = true;
          this.discountMessage = this.discount;
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Discount application error:', error); // Handle different types of errors

        this.discountError = true;
        this.discountMessage = 'Invalid code. Please try again.';
      } finally {
        this.isApplyingDiscount = false;
      }
    }

  }
});
;// CONCATENATED MODULE: ./src/scripts/vue/components/CartDrawerFooter.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_CartDrawerFootervue_type_script_lang_js_ = (CartDrawerFootervue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./src/scripts/vue/components/CartDrawerFooter.vue





/* normalize component */
;
var CartDrawerFooter_component = (0,componentNormalizer/* default */.Z)(
  components_CartDrawerFootervue_type_script_lang_js_,
  CartDrawerFootervue_type_template_id_c4791b02_render,
  CartDrawerFootervue_type_template_id_c4791b02_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CartDrawerFooter = (CartDrawerFooter_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/CartDrawer.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var CartDrawervue_type_script_lang_js_ = ({
  name: 'CartDrawer',
  components: {
    CartDrawerHeader: CartDrawerHeader,
    CartDrawerContent: CartDrawerContent,
    CartDrawerFooter: CartDrawerFooter,
    Loading: Loading/* default */.Z
  },
  props: {
    cart: {
      type: Object,
      required: true
    },
    enableUpsell: {
      type: Boolean,
      required: false,
      default: false
    },
    enableCrossSell: {
      type: Boolean,
      required: false,
      default: false
    },
    upsellTitle: {
      type: String,
      required: false,
      default: ''
    },
    crossSellTitle: {
      type: String,
      required: false,
      default: ''
    },
    upsellProducts: {
      type: Array,
      required: false,
      default: () => []
    },
    crossSellProducts: {
      type: Array,
      required: false,
      default: () => []
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    handleCartUpdate(cartState) {
      this.$emit('cart-updated', cartState);
    },

    handleApplyDiscount(discount) {
      this.$emit('apply-discount', discount);
    }

  }
});
;// CONCATENATED MODULE: ./src/scripts/vue/components/CartDrawer.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_CartDrawervue_type_script_lang_js_ = (CartDrawervue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./src/scripts/vue/components/CartDrawer.vue





/* normalize component */
;
var CartDrawer_component = (0,componentNormalizer/* default */.Z)(
  components_CartDrawervue_type_script_lang_js_,
  CartDrawervue_type_template_id_f45abcce_render,
  CartDrawervue_type_template_id_f45abcce_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CartDrawer = (CartDrawer_component.exports);
;// CONCATENATED MODULE: ./src/scripts/sections/drawer.js




vue_min_default().use((dist_default()));
window.PSTheme.Vue.Drawer = new (vue_min_default())({
  name: 'Drawer',
  components: {
    CartDrawer: CartDrawer
  },

  data() {
    return {
      showDrawer: false,
      drawerMode: 'cart',
      // 'default' or 'cart'
      cart: null,
      loading: false
    };
  },

  methods: {
    openDrawer(mode = 'default', cartData = null) {
      this.drawerMode = mode;

      if (mode === 'cart' && cartData) {
        this.cart = cartData;
      }

      this.showDrawer = true; // Prevent body scroll when drawer is open

      document.body.style.overflow = 'hidden';
    },

    openCartDrawer(cartData) {
      this.openDrawer('cart', cartData);
    },

    closeDrawer() {
      this.showDrawer = false;
      this.drawerMode = 'default';
      this.cart = null; // Restore body scroll when drawer is closed

      document.body.style.overflow = '';
    },

    async toggleDrawer() {
      if (this.showDrawer) {
        this.closeDrawer();
      } else {
        // Fetch cart data before opening the drawer
        try {
          const cartData = await (0,cart/* getState */.y0)();
          this.cart = cartData;
          this.openDrawer('cart', cartData);
        } catch (error) {
          console.error('Failed to load cart data:', error); // Fallback to opening with empty cart

          this.openDrawer('cart', {
            items: [],
            item_count: 0,
            total_price: 0
          });
        }
      }
    },

    addingToCart(addingState) {
      this.loading = addingState;
    },

    handleCartUpdate(cartState) {
      this.loading = true;
      this.cart = cartState; // Emit event for other components to listen to

      this.$emit('cart-updated', cartState);
      this.loading = false;
    },

    goToCart() {
      window.location.href = '/cart';
    },

    checkout() {
      window.location.href = '/checkout';
    }

  },

  mounted() {
    // Add class to show drawer container now that Vue is mounted
    this.$el.classList.add('vue-mounted'); // Make drawer methods globally accessible

    window.PSTheme.Drawer = {
      open: this.openDrawer,
      openCart: this.openCartDrawer,
      close: this.closeDrawer,
      toggle: this.toggleDrawer,
      addingToCart: this.addingToCart
    }; // Listen for escape key to close drawer

    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && this.showDrawer) {
        this.closeDrawer();
      }
    });
  },

  beforeDestroy() {
    // Clean up body overflow when component is destroyed
    document.body.style.overflow = '';
  }

}).$mount('.app__drawer');
;// CONCATENATED MODULE: ./src/scripts/layout/theme.js
/* styles */

/* utils */



/* vue */


/* global */






/***/ }),

/***/ 9508:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RS": function() { return /* binding */ mq_breakpoints; },
/* harmony export */   "ku": function() { return /* binding */ px_breakpoints; }
/* harmony export */ });
/* unused harmony export px_queries */
// EMs
let mq_breakpoints = {
  '--mobile-down': '(max-width: 25.99em)',
  '--mobile-up': '(min-width: 26em)',
  '--phablet-down': '(min-width: 32.49em)',
  '--phablet-up': '(min-width: 32.5em)',
  '--tablet-down': '(max-width: 39.99em)',
  '--tablet-up': '(min-width: 40em)',
  '--tablet-lg-down': '(min-width: 63.99em)',
  '--tablet-lg-up': '(min-width: 64em)',
  '--laptop-down': '(max-width: 71.99em)',
  '--laptop-up': '(min-width: 72em)',
  '--desktop-down': '(max-width: 99.99em)',
  '--desktop-up': '(min-width: 100em)',
  '--ultrawide': '(min-width: 125em)'
}; // Pixels

let px_breakpoints = {
  '--mobile-up': 416,
  '--phablet-up': 520,
  '--tablet-up': 640,
  '--tablet-lg-up': 1024,
  '--laptop-up': 1152,
  '--desktop-up': 1600,
  '--ultrawide': 2000
};
let px_queries = {
  '--mobile-up': '(min-width: 416px)',
  '--phablet-up': '(min-width: 520px)',
  '--tablet-up': '(min-width: 640px)',
  '--tablet-lg-up': '(min-width: 1024px)',
  '--laptop-up': '(min-width: 1152px)',
  '--desktop-up': '(min-width: 1600px)',
  '--ultrawide': '(min-width: 2000px)'
};


/***/ }),

/***/ 7342:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y0": function() { return /* binding */ getState; },
/* harmony export */   "jX": function() { return /* binding */ addItem; },
/* harmony export */   "$G": function() { return /* binding */ updateItem; },
/* harmony export */   "XO": function() { return /* binding */ updateItemQuantityById; },
/* harmony export */   "Qk": function() { return /* binding */ updateNote; },
/* harmony export */   "xu": function() { return /* binding */ updateCart; }
/* harmony export */ });
/* unused harmony exports getItemIndex, getItem, addItemFromForm, removeItem, clearItems, getAttributes, updateAttributes, clearAttributes, getNote, clearNote, getShippingRates */
/**
 * Cart API helper methods
 * ------------------------------------------------------------------------------
 * Reusable code for cart API methods
 *
 */

/**
 * Returns the state object of the cart
 * @returns {Promise} Resolves with the state object of the cart (https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#get-cart)
 */
function getState() {
  return cart();
}
/**
 * Returns the index of the cart line item
 * @param {string} key The unique key of the line item
 * @returns {Promise} Resolves with the index number of the line item
 */

function getItemIndex(key) {
  validate_key(key);
  return cart().then(function (state) {
    var index = -1;
    state.items.forEach(function (item, i) {
      index = item.key === key ? i + 1 : index;
    });

    if (index === -1) {
      return Promise.reject(new Error('Theme Cart: Unable to match line item with provided key'));
    }

    return index;
  });
}
/**
 * Fetches the line item object
 * @param {string} key The unique key of the line item
 * @returns {Promise} Resolves with the line item object (See response of cart/add.js https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#add-to-cart)
 */

function getItem(key) {
  validate_key(key);
  return cart().then(function (state) {
    var lineItem = null;
    state.items.forEach(function (item) {
      lineItem = item.key === key ? item : lineItem;
    });

    if (lineItem === null) {
      return Promise.reject(new Error('Theme Cart: Unable to match line item with provided key'));
    }

    return lineItem;
  });
}
/**
 * Add a new line item to the cart
 * @param {number} id The variant's unique ID
 * @param {object} options Optional values to pass to /cart/add.js
 * @param {number} options.quantity The quantity of items to be added to the cart
 * @param {object} options.properties Line item property key/values (https://help.shopify.com/en/themes/liquid/objects/line_item#line_item-properties)
 * @returns {Promise} Resolves with the line item object (See response of cart/add.js https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#add-to-cart)
 */

function addItem(id, options) {
  options = options || {};
  validate_id(id);
  return cartAdd(id, options.quantity, options.properties);
}
/**
 * Add a new line item to the cart from a product form
 * @param {object} form DOM element which is equal to the <form> node
 * @returns {Promise} Resolves with the line item object (See response of cart/add.js https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#add-to-cart)
 */

function addItemFromForm(form) {
  validate_form(form);
  var formData = new FormData(form);
  validate_id(parseInt(formData.get('id'), 10));
  return cartAddFromForm(formData);
}
/**
 * Changes the quantity and/or properties of an existing line item.
 * @param {string} key The unique key of the line item (https://help.shopify.com/en/themes/liquid/objects/line_item#line_item-key)
 * @param {object} options Optional values to pass to /cart/add.js
 * @param {number} options.quantity The quantity of items to be added to the cart
 * @param {object} options.properties Line item property key/values (https://help.shopify.com/en/themes/liquid/objects/line_item#line_item-properties)
 * @returns {Promise} Resolves with the state object of the cart (https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#get-cart)
 */

function updateItem(key, options) {
  validate_key(key);
  validate_options(options);
  return getItemIndex(key).then(function (line) {
    return cartChange(line, options);
  });
}
/**
 * 
 * Changes the quantity of an existing line item through it's variant id, useful when the key is not accessable.
 * @param {integer} variant.id
 * @param {number} quantity Setting to 0 will remove the item
 */

function updateItemQuantityById(id, qty) {
  return cartUpdateQuantityById(id, qty);
}
/**
 * Removes a line item from the cart
 * @param {string} key The unique key of the line item (https://help.shopify.com/en/themes/liquid/objects/line_item#line_item-key)
 * @returns {Promise} Resolves with the state object of the cart (https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#get-cart)
 */

function removeItem(key) {
  validate_key(key);
  return getItemIndex(key).then(function (line) {
    return cartChange(line, {
      quantity: 0
    });
  });
}
/**
 * Sets all quantities of all line items in the cart to zero. This does not remove cart attributes nor the cart note.
 * @returns {Promise} Resolves with the state object of the cart (https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#get-cart)
 */

function clearItems() {
  return cartClear();
}
/**
 * Gets all cart attributes
 * @returns {Promise} Resolves with the cart attributes object
 */

function getAttributes() {
  return cart().then(function (state) {
    return state.attributes;
  });
}
/**
 * Sets all cart attributes
 * @returns {Promise} Resolves with the cart state object
 */

function updateAttributes(attributes) {
  return cartUpdate({
    attributes: attributes
  });
}
/**
 * Clears all cart attributes
 * @returns {Promise} Resolves with the cart state object
 */

function clearAttributes() {
  return getAttributes().then(function (attributes) {
    for (var key in attributes) {
      attributes[key] = '';
    }

    return updateAttributes(attributes);
  });
}
/**
 * Gets cart note
 * @returns {Promise} Resolves with the cart note string
 */

function getNote() {
  return cart().then(function (state) {
    return state.note;
  });
}
/**
 * Sets cart note
 * @returns {Promise} Resolves with the cart state object
 */

function updateNote(note) {
  return cartUpdate({
    note: note
  });
}
/**
 * Updates cart with discount codes, attributes, or other cart properties
 * @param {object} body The cart update data (e.g., { discount: 'CODE' })
 * @returns {Promise} Resolves with the updated cart state object
 */

function updateCart(body) {
  return cartUpdate(body);
}
/**
 * Clears cart note
 * @returns {Promise} Resolves with the cart state object
 */

function clearNote() {
  return cartUpdate({
    note: ''
  });
}
/**
 * Get estimated shipping rates.
 * @returns {Promise} Resolves with response of /cart/shipping_rates.json (https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#get-shipping-rates)
 */

function getShippingRates() {
  return cartShippingRates();
}
/**
 * Request helper functions
 */

function getDefaultRequestConfig() {
  return JSON.parse(JSON.stringify({
    credentials: 'same-origin',
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/json;'
    }
  }));
}

function fetchJSON(url, config) {
  return fetch(url, config).then(function (response) {
    if (!response.ok) {
      throw response;
    }

    return response.json();
  });
}

function cart() {
  return fetchJSON('/cart.js', getDefaultRequestConfig());
}

function cartAdd(id, quantity, properties) {
  var config = getDefaultRequestConfig();
  config.method = 'POST';
  config.body = JSON.stringify({
    id: id,
    quantity: quantity,
    properties: properties
  });
  return fetchJSON('/cart/add.js', config);
}

function cartAddFromForm(formData) {
  var config = getDefaultRequestConfig();
  delete config.headers['Content-Type'];
  config.method = 'POST';
  config.body = formData;
  return fetchJSON('/cart/add.js', config);
}

function cartChange(line, options) {
  var config = getDefaultRequestConfig();
  options = options || {};
  config.method = 'POST';
  config.body = JSON.stringify({
    line: line,
    quantity: options.quantity,
    properties: options.properties
  });
  return fetchJSON('/cart/change.js', config);
}

function cartUpdateQuantityById(id, qty) {
  var config = getDefaultRequestConfig();
  delete config.headers['Content-Type'];
  config.method = 'POST';
  config.body = new URLSearchParams(`quantity=${qty}&id=${id}`);
  return fetchJSON('/cart/change.js', config);
}

function cartClear() {
  var config = getDefaultRequestConfig();
  config.method = 'POST';
  return fetchJSON('/cart/clear.js', config);
}

function cartUpdate(body) {
  var config = getDefaultRequestConfig();
  config.method = 'POST';
  config.body = JSON.stringify(body);
  return fetchJSON('/cart/update.js', config);
}

function cartShippingRates() {
  return fetchJSON('/cart/shipping_rates.json', getDefaultRequestConfig());
}
/**
 * Validation helper functions
 */


function validate_key(key) {
  if (typeof key !== 'string' || key.split(':').length !== 2) {
    throw new TypeError('Theme Cart: Provided key value is not a string with the format xxx:xxx');
  }
}

function validate_quantity(quantity) {
  if (typeof quantity !== 'number' || isNaN(quantity)) {
    throw new TypeError('Theme Cart: An object which specifies a quantity or properties value is required');
  }
}

function validate_id(id) {
  if (typeof id !== 'number' || isNaN(id)) {
    throw new TypeError('Theme Cart: Variant ID must be a number');
  }
}

function validate_properties(properties) {
  if (typeof properties !== 'object') {
    throw new TypeError('Theme Cart: Properties must be an object');
  }
}

function validate_form(form) {
  if (!(form instanceof HTMLFormElement)) {
    throw new TypeError('Theme Cart: Form must be an instance of HTMLFormElement');
  }
}

function validate_options(options) {
  if (typeof options !== 'object') {
    throw new TypeError('Theme Cart: Options must be an object');
  }

  if (typeof options.quantity === 'undefined' && typeof options.properties === 'undefined') {
    throw new Error('Theme Cart: You muse define a value for quantity or properties');
  }

  if (typeof options.quantity !== 'undefined') {
    validate_quantity(options.quantity);
  }

  if (typeof options.properties !== 'undefined') {
    validate_properties(options.properties);
  }
}

/***/ }),

/***/ 3200:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {


// EXTERNAL MODULE: ./node_modules/vue/dist/vue.min.js
var vue_min = __webpack_require__(9346);
var vue_min_default = /*#__PURE__*/__webpack_require__.n(vue_min);
;// CONCATENATED MODULE: ./src/scripts/vue/store/global.js

const store = vue_min_default().observable({
  menuActive: false,
  searchActive: false,
  notificationsActive: false,
  closeAnnouncement: false,
  customerCountry: 'NZ'
});
const actions = {
  openMenu() {
    store.menuActive = true;
  },

  toggleMenu() {
    if (store.menuActive) {
      this.closeAll();
    } else {
      this.closeAll();
      store.menuActive = true;
    }
  },

  toggleSearch() {
    store.searchActive = !store.searchActive;
  },

  toggleNotifications() {
    store.notificationsActive = !store.notificationsActive;
  },

  closeAll() {
    store.menuActive = false;
    store.searchActive = false;
    store.notificationsActive = false;
    window.PSTheme.Vue.Header.secondMenuIdx = null;
    window.PSTheme.Vue.Header.thirdMenuIdx = null;
  }

};
(vue_min_default()).prototype.$store = store;
(vue_min_default()).prototype.$actions = actions;
// EXTERNAL MODULE: ./src/scripts/utils/breakpoints.js
var breakpoints = __webpack_require__(9508);
// EXTERNAL MODULE: ./node_modules/@vue/composition-api/dist/vue-composition-api.mjs
var vue_composition_api = __webpack_require__(5706);
// EXTERNAL MODULE: ./node_modules/vue-screen/dist/vue-screen.esm.js
var vue_screen_esm = __webpack_require__(6768);
// EXTERNAL MODULE: ./node_modules/@shopify/theme-currency/currency.js
var currency = __webpack_require__(1186);
// EXTERNAL MODULE: ./node_modules/@shopify/theme-images/images.js
var theme_images_images = __webpack_require__(3253);
;// CONCATENATED MODULE: ./src/scripts/vue/main.js







/* config */

(vue_min_default()).config.devtools = true;
(vue_min_default()).config.productionTip = false;
(vue_min_default()).config.silent = true;
/* extensions */

(vue_min_default()).prototype.$language = globalThis.PSTheme.Language;
(vue_min_default()).prototype.$settings = globalThis.PSTheme.Settings;
(vue_min_default()).prototype.$customer = globalThis.PSTheme.Customer;

(vue_min_default()).prototype.$image = (src, size = '750x') => theme_images_images/* getSizedImageUrl */.M0(src, size);

(vue_min_default()).prototype.$preloadImages = (imgArray, size = '750x') => theme_images_images/* preload */.MA(imgArray, size);

(vue_min_default()).prototype.$money = amount => (0,currency/* formatMoney */.l)(amount, '${{amount}}');

(vue_min_default()).prototype.$isEmpty = obj => {
  if (obj && Object.keys(obj).length === 0 && obj.constructor === Object) return true;
};
/* plugins */


vue_min_default().use(vue_composition_api/* default */.ZP);
vue_min_default().use(vue_screen_esm/* default */.Z, {
  mobile_up: breakpoints/* px_breakpoints.--mobile-up */.ku["--mobile-up"],
  tablet_up: breakpoints/* px_breakpoints.--tablet-up */.ku["--tablet-up"],
  tablet_lg_up: breakpoints/* px_breakpoints.--tablet-lg-up */.ku["--tablet-lg-up"],
  laptop_up: breakpoints/* px_breakpoints.--laptop-up */.ku["--laptop-up"],
  desktop_up: breakpoints/* px_breakpoints.--desktop-up */.ku["--desktop-up"]
});

/***/ }),

/***/ 6175:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Gallery; }
});

;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/Gallery.vue?vue&type=template&id=a7289e28&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gallery",class:{ loaded: _vm.featuredLazyLoaded }},[_c('div',{staticClass:"gallery__thumbnails"},[_c('Slider',{ref:"thumbnails",attrs:{"options":_vm.thumbnailOptions}},_vm._l((_vm.media),function(media,idx){return _c('Slide',{key:idx,staticClass:"slide--thumbnail",staticStyle:{"--aspect-ratio":"2/3"}},[(media.media_type == 'video')?_c('div',{ref:"div",refInFor:true,staticClass:"video-thumb"},[_c('VImg',{attrs:{"media":media.preview_image,"fixedSize":"250x","alt":"Gallery Thumbnail"}}),_vm._v(" "),_c('PlayIcon')],1):_c('VImg',{attrs:{"media":media,"fixedSize":"250x","alt":"Gallery Thumbnail"}})],1)}),1),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.toShow > 0 && _vm.images.length > 4),expression:"toShow > 0 && images.length > 4"}],staticClass:"gallery__showmore"},[_vm._v("\n      "+_vm._s(("+" + _vm.toShow + " more images"))+"\n    ")])],1),_vm._v(" "),_c('div',{staticClass:"gallery__main"},[_c('Slider',{ref:"gallery",attrs:{"options":_vm.galleryOptions},on:{"splide:moved":_vm.onMoved,"splide:mounted":_vm.onMoved}},_vm._l((_vm.media),function(media,idx){return _c('Slide',{key:idx,staticClass:"slide--main"},[(media.media_type == 'video')?_c('div',{staticClass:"video-wrapper"},[_c('video',{staticClass:"lazyload",attrs:{"preload":"none","muted":"","loop":"","playsinline":"","autoplay":"","data-poster":media.preview_image.src,"loading":idx === 0 ? 'eager' : 'lazy'},domProps:{"muted":true}},[_c('source',{key:idx,attrs:{"src":_vm.videoSourceURL(media.sources)}}),_vm._v("\n            Sorry, your browser doesn't support embedded videos.\n          ")])]):_c('div',{staticClass:"image-wrapper",on:{"mousemove":function($event){return _vm.zoom($event, media)}}},[_c('VImg',{attrs:{"media":media,"alt":"Gallery Main","loading_method":idx === 0 ? 'eager' : 'lazy'}})],1)])}),1)],1)])}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/@splidejs/vue-splide/src/js/index.js + 9 modules
var js = __webpack_require__(5493);
// EXTERNAL MODULE: ./src/scripts/utils/breakpoints.js
var breakpoints = __webpack_require__(9508);
// EXTERNAL MODULE: ./src/scripts/vue/components/VImg.vue + 3 modules
var VImg = __webpack_require__(3133);
;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/icons/PlayIcon.vue?vue&type=template&id=fe28ac4e&functional=true&
var PlayIconvue_type_template_id_fe28ac4e_functional_true_render = function (_h,_vm) {var _c=_vm._c;return _c('svg',{staticStyle:{"enable-background":"new 0 0 512 512"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512","xml:space":"preserve"}},[_c('path',{attrs:{"fill":"#E2CEBD","d":"M256 0C114.833 0 0 114.844 0 256s114.833 256 256 256 256-114.844 256-256S397.167 0 256 0zm101.771 264.969-149.333 96a10.62 10.62 0 0 1-5.771 1.698c-1.75 0-3.521-.438-5.104-1.302A10.653 10.653 0 0 1 192 352V160c0-3.906 2.125-7.49 5.563-9.365 3.375-1.854 7.604-1.74 10.875.396l149.333 96c3.042 1.958 4.896 5.344 4.896 8.969s-1.854 7.01-4.896 8.969z"}})])}
var PlayIconvue_type_template_id_fe28ac4e_functional_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/icons/PlayIcon.vue?vue&type=script&lang=js&
//
//
//
//
/* harmony default export */ var PlayIconvue_type_script_lang_js_ = ({
  name: 'PlayIcon'
});
;// CONCATENATED MODULE: ./src/scripts/vue/icons/PlayIcon.vue?vue&type=script&lang=js&
 /* harmony default export */ var icons_PlayIconvue_type_script_lang_js_ = (PlayIconvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1900);
;// CONCATENATED MODULE: ./src/scripts/vue/icons/PlayIcon.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.Z)(
  icons_PlayIconvue_type_script_lang_js_,
  PlayIconvue_type_template_id_fe28ac4e_functional_true_render,
  PlayIconvue_type_template_id_fe28ac4e_functional_true_staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* harmony default export */ var PlayIcon = (component.exports);
// EXTERNAL MODULE: ./node_modules/@splidejs/splide/dist/css/themes/splide-default.min.css
var splide_default_min = __webpack_require__(881);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/Gallery.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



 // eslint-disable-next-line import/no-extraneous-dependencies


/* harmony default export */ var Galleryvue_type_script_lang_js_ = ({
  name: 'Gallery',
  components: {
    VImg: VImg/* default */.Z,
    PlayIcon: PlayIcon,
    Slider: js/* Splide */.tv,
    Slide: js/* SplideSlide */.jw
  },
  props: {
    media: {
      type: Array,
      default: () => []
    },
    images: {
      type: Array,
      default: () => []
    },
    forcePagination: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    galleryOptions() {
      return {
        pagination: this.forcePagination,
        breakpoints: {
          [breakpoints/* px_breakpoints.--laptop-up */.ku["--laptop-up"]]: {
            pagination: this.forcePagination || true
          }
        }
      };
    }

  },

  data() {
    return {
      thumbnailOptions: {
        height: '40rem',
        fixedHeight: '9rem',
        gap: '1rem',
        direction: 'ttb',
        drag: false,
        perPage: 4,
        perMove: 1,
        pagination: false,
        isNavigation: true,
        breakpoints: {
          [breakpoints/* px_breakpoints.--tablet-up */.ku["--tablet-up"]]: {
            destroy: false
          },
          [breakpoints/* px_breakpoints.--tablet-lg-up */.ku["--tablet-lg-up"]]: {
            destroy: true
          }
        }
      },
      featuredLazyLoaded: false,
      toShow: 0
    };
  },

  mounted() {
    // Syncing the two sliders together so that when you click on a thumbnail, the main slider
    // will move to the corresponding image.
    this.$refs.gallery.sync(this.$refs.thumbnails.splide);
    document.querySelector('.gallery');
    this.$preloadImages(this.images, '750x');
  },

  methods: {
    zoom(event, media) {
      if (this.$screen.laptop_up) {
        const zoomer = event.currentTarget;
        zoomer.style.backgroundImage = `url(${media.src})`;
        let offsetX = 0;
        let offsetY = 0;
        event.offsetX ? offsetX = event.offsetX : offsetX = event.touches[0].pageX;
        event.offsetY ? offsetY = event.offsetY : offsetY = event.touches[0].pageY;
        const x = offsetX / zoomer.offsetWidth * 100;
        const y = offsetY / zoomer.offsetHeight * 100;
        zoomer.style.backgroundPosition = `${x}% ${y}%`;
      }
    },

    // Finding the highest quality video source.
    videoSourceURL(sources) {
      let ten80;
      let seven20;
      let four80 = false;

      for (const source of sources) {
        if (source.url.includes('1080p')) ten80 = source.url;
        if (source.url.includes('720p')) seven20 = source.url;
        if (source.url.includes('480p')) four80 = source.url;
      }

      return ten80 || seven20 || four80 || sources.pop().url;
    },

    // It's a method that is called when the gallery is moved. It's used to calculate how many more images
    // are left to show.
    onMoved() {
      this.toShow = this.$refs.gallery.splide.length - this.$refs.gallery.splide.index - 1;
    }

  }
});
;// CONCATENATED MODULE: ./src/scripts/vue/components/Gallery.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_Galleryvue_type_script_lang_js_ = (Galleryvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./src/scripts/vue/components/Gallery.vue





/* normalize component */
;
var Gallery_component = (0,componentNormalizer/* default */.Z)(
  components_Galleryvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Gallery = (Gallery_component.exports);

/***/ }),

/***/ 2347:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Installments; }
});

;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/Installments.vue?vue&type=template&id=d9b6f562&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product__installments"},[(_vm.afterpay)?_c('div',{staticClass:"product__installments-wrapper"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.showAfterpay),expression:"showAfterpay"}],staticClass:"product__installments-text"},[_vm._v("\n      or 4x "),_c('strong',[_vm._v(_vm._s(_vm.$money(_vm.total / 4)))]),_vm._v(" fortnightly with\n      "),_c('img',{staticClass:"product__installments-image lazyload",attrs:{"data-src":"https://static.afterpay.com/integration/product-page/logo-afterpay-colour@2x.png","alt":"Afterpay"}})])]):_vm._e(),_vm._v(" "),(_vm.zip)?_c('div',{staticClass:"product__installments-wrapper"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.showZip),expression:"showZip"}],staticClass:"product__installments-text"},[_vm._v("\n      or 4x "),_c('strong',[_vm._v(_vm._s(_vm.$money(_vm.total / 4)))]),_vm._v(" with\n      "),_c('img',{staticClass:"product__installments-image lazyload",attrs:{"data-src":"https://zip.co/nz/wp-content/uploads/2021/08/logo.svg","alt":"Zip"}})])]):_vm._e()])}
var staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/Installments.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var Installmentsvue_type_script_lang_js_ = ({
  name: 'Installments',
  props: ['afterpay', 'zip', 'total'],
  computed: {
    showAfterpay() {
      return ['AU', 'NZ'].includes(this.$store.customerCountry);
    },

    showZip() {
      return ['AU', 'NZ', 'GB'].includes(this.$store.customerCountry);
    }

  }
});
;// CONCATENATED MODULE: ./src/scripts/vue/components/Installments.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_Installmentsvue_type_script_lang_js_ = (Installmentsvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js
var injectStylesIntoStyleTag = __webpack_require__(3379);
var injectStylesIntoStyleTag_default = /*#__PURE__*/__webpack_require__.n(injectStylesIntoStyleTag);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/styleDomAPI.js
var styleDomAPI = __webpack_require__(7795);
var styleDomAPI_default = /*#__PURE__*/__webpack_require__.n(styleDomAPI);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/insertBySelector.js
var insertBySelector = __webpack_require__(569);
var insertBySelector_default = /*#__PURE__*/__webpack_require__.n(insertBySelector);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js
var setAttributesWithoutAttributes = __webpack_require__(3565);
var setAttributesWithoutAttributes_default = /*#__PURE__*/__webpack_require__.n(setAttributesWithoutAttributes);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/insertStyleElement.js
var insertStyleElement = __webpack_require__(9216);
var insertStyleElement_default = /*#__PURE__*/__webpack_require__.n(insertStyleElement);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/styleTagTransform.js
var styleTagTransform = __webpack_require__(4589);
var styleTagTransform_default = /*#__PURE__*/__webpack_require__.n(styleTagTransform);
// EXTERNAL MODULE: ./node_modules/@ps-devs/shopify-webpack/node_modules/css-loader/dist/cjs.js??clonedRuleSet-5[0].rules[0].use[1]!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/Installments.vue?vue&type=style&index=0&lang=css&
var Installmentsvue_type_style_index_0_lang_css_ = __webpack_require__(5723);
;// CONCATENATED MODULE: ./node_modules/style-loader/dist/cjs.js!./node_modules/@ps-devs/shopify-webpack/node_modules/css-loader/dist/cjs.js??clonedRuleSet-5[0].rules[0].use[1]!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/Installments.vue?vue&type=style&index=0&lang=css&

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (styleTagTransform_default());
options.setAttributes = (setAttributesWithoutAttributes_default());

      options.insert = insertBySelector_default().bind(null, "head");
    
options.domAPI = (styleDomAPI_default());
options.insertStyleElement = (insertStyleElement_default());

var update = injectStylesIntoStyleTag_default()(Installmentsvue_type_style_index_0_lang_css_/* default */.Z, options);




       /* harmony default export */ var components_Installmentsvue_type_style_index_0_lang_css_ = (Installmentsvue_type_style_index_0_lang_css_/* default */.Z && Installmentsvue_type_style_index_0_lang_css_/* default.locals */.Z.locals ? Installmentsvue_type_style_index_0_lang_css_/* default.locals */.Z.locals : undefined);

;// CONCATENATED MODULE: ./src/scripts/vue/components/Installments.vue?vue&type=style&index=0&lang=css&

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1900);
;// CONCATENATED MODULE: ./src/scripts/vue/components/Installments.vue



;


/* normalize component */

var component = (0,componentNormalizer/* default */.Z)(
  components_Installmentsvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Installments = (component.exports);

/***/ }),

/***/ 9918:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Loading; }
});

;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/Loading.vue?vue&type=template&id=b5c84ec2&functional=true&
var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{class:[ 'site-loading', { 'activated': _vm.props.activated }],staticStyle:{"z-index":"100"}},[_vm._m(0)])}
var staticRenderFns = [function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"spinner"},[_c('div',{staticClass:"circle one"}),_vm._v(" "),_c('div',{staticClass:"circle two"})])}]


;// CONCATENATED MODULE: ./src/scripts/vue/components/Loading.vue?vue&type=template&id=b5c84ec2&functional=true&

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/Loading.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var Loadingvue_type_script_lang_js_ = ({
  name: 'Loading',
  props: ['activated']
});
;// CONCATENATED MODULE: ./src/scripts/vue/components/Loading.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_Loadingvue_type_script_lang_js_ = (Loadingvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1900);
;// CONCATENATED MODULE: ./src/scripts/vue/components/Loading.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.Z)(
  components_Loadingvue_type_script_lang_js_,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* harmony default export */ var Loading = (component.exports);

/***/ }),

/***/ 82:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ProductForm; }
});

;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/ProductForm.vue?vue&type=template&id=73a4fb0f&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{ref:"form",staticClass:"product__details-form",attrs:{"method":"post","action":"/cart/add","accept-charset":"UTF-8","enctype":"multipart/form-data"}},[_c('input',{attrs:{"type":"hidden","name":"id"},domProps:{"value":_vm.activeVariant.id ? _vm.activeVariant.id : ''}}),_vm._v(" "),(!_vm.hasDefaultVariant)?[(_vm.options.length == 1)?_c('div',[_c('div',{staticClass:"product__form-option"},[_c('span',{staticClass:"option__name"},[_vm._v("Pick Your "+_vm._s(_vm.options[0])+":")]),_vm._v(" "),_c('div',{staticClass:"option__values"},_vm._l((_vm.variants),function(variant){return _c('label',{key:variant.id,class:['option__label', { disabled: !variant.available }],attrs:{"for":("option-" + (variant.id))}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedOptions['option1']),expression:"selectedOptions['option1']"}],attrs:{"type":"radio","id":("option-" + (variant.id))},domProps:{"value":variant.title,"checked":_vm._q(_vm.selectedOptions['option1'],variant.title)},on:{"change":[function($event){return _vm.$set(_vm.selectedOptions, 'option1', variant.title)},function($event){return _vm.onOptionChange()}]}}),_vm._v(" "),_c('span',{staticClass:"option__button"},[_vm._v("\n              "+_vm._s(variant.title.replace('.00', ''))+"\n            ")])])}),0)])]):_c('div',_vm._l((_vm.options),function(option){return _c('div',{key:option.id,staticClass:"product__form-option"},[_c('span',{staticClass:"option__name"},[_vm._v("Pick Your "+_vm._s(option.name)+":")]),_vm._v(" "),_c('div',{staticClass:"option__values"},_vm._l((option.values),function(value,idx){return _c('label',{key:idx,staticClass:"option__label",attrs:{"for":("option-" + (option.name) + "-" + idx)}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedOptions[("option" + (option.position))]),expression:"selectedOptions[`option${option.position}`]"}],attrs:{"type":"radio","id":("option-" + (option.name) + "-" + idx)},domProps:{"value":value,"checked":_vm._q(_vm.selectedOptions[("option" + (option.position))],value)},on:{"change":[function($event){return _vm.$set(_vm.selectedOptions, ("option" + (option.position)), value)},function($event){return _vm.onOptionChange()}]}}),_vm._v(" "),_c('span',{staticClass:"option__button"},[_vm._v("\n              "+_vm._s(value)+"\n            ")])])}),0)])}),0)]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"product__form-buttons"},[_c('button',{staticClass:"btn btn--primary",class:{ 'product__form-added-to-cart': _vm.added },attrs:{"disabled":!_vm.activeVariant || !_vm.available},domProps:{"textContent":_vm._s(_vm.added ? _vm.successText : _vm.addToCartText)},on:{"click":function($event){$event.preventDefault();return _vm.addToCart(_vm.activeVariant.id)}}}),_vm._v(" "),_c('div',{ref:"insert-wishlist"})])],2)}
var staticRenderFns = []


// EXTERNAL MODULE: ./src/scripts/utils/cart.js
var cart = __webpack_require__(7342);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/ProductForm.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var ProductFormvue_type_script_lang_js_ = ({
  name: 'ProductForm',
  props: ['options', 'variants', 'available', 'activeVariant', 'hasDefaultVariant'],
  computed: {
    addToCartText() {
      if (this.activeVariant.id) {
        return this.available ? this.$language.product.add_to_cart : this.$language.product.sold_out;
      }

      return 'Pick Your Size';
    },

    successText() {
      return this.$language.product.add_to_cart_success;
    }

  },

  data() {
    return {
      added: false,
      selectedOptions: {
        option1: '',
        option2: '',
        option3: ''
      }
    };
  },

  mounted() {
    // Create a comment for the wishlist app to observe
    if (window.PSTheme.Settings.Outlet === false && this.$parent.product) {
      const wishlistBtn = document.createComment(` include 'wishlist-button-product' with '${this.$parent.product.id}' `);
      this.$refs['insert-wishlist'].appendChild(wishlistBtn);
    }
  },

  methods: {
    onOptionChange() {
      this.updateVariant();
    },

    updateVariant() {
      // Updating the variant based on the selected options
      const optLength = this.options.length;
      this.variants.forEach(variant => {
        if (optLength === 1 && this.selectedOptions.option1 === variant.option1) {
          this.$emit('update:variant', variant);
        } else if (optLength === 2 && this.selectedOptions.option1 === variant.option1 && this.selectedOptions.option2 === variant.option2) {
          this.$emit('update:variant', variant);
        } else if (this.selectedOptions.option1 === variant.option1 && this.selectedOptions.option2 === variant.option2 && this.selectedOptions.option3 === variant.option3) {
          this.$emit('update:variant', variant);
        }
      });
    },

    addToCart(vID) {
      if (window.PSTheme.Settings.CartDrawer == true) {
        window.PSTheme.Vue.Drawer.openDrawer('cart', null);
      }

      window.PSTheme.Vue.Drawer.addingToCart(true);
      (0,cart/* addItem */.jX)(vID).then(() => (0,cart/* getState */.y0)()).then(cartState => {
        this.added = true;
        window.PSTheme.Vue.Header.updateCartCount(1);

        if (window.PSTheme.Settings.CartDrawer == true) {
          window.PSTheme.Vue.Drawer.openDrawer('cart', cartState);
        } // Emit success event for parent components to handle


        this.$emit('cart-success', cartState);

        if (window.PSTheme.Settings.CartDrawer == true) {
          window.PSTheme.Vue.Drawer.addingToCart(false);
        }

        console.log('cartState', cartState);
        setTimeout(() => {
          this.added = false;
        }, 2000);
      });
    }

  }
});
;// CONCATENATED MODULE: ./src/scripts/vue/components/ProductForm.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_ProductFormvue_type_script_lang_js_ = (ProductFormvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1900);
;// CONCATENATED MODULE: ./src/scripts/vue/components/ProductForm.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.Z)(
  components_ProductFormvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ProductForm = (component.exports);

/***/ }),

/***/ 3133:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ VImg; }
});

;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/VImg.vue?vue&type=template&id=4a5ed573&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"vimg",class:_vm.customClass,attrs:{"src":_vm.fixedSize ? _vm.$image(_vm.media.src, _vm.fixedSize) : _vm.$image(_vm.media.src),"srcset":_vm.fixedSize ? '' : _vm.srcset,"data-sizes":"auto","alt":_vm.media.alt || _vm.$attrs.alt || 'Image',"loading":_vm.loading_method || 'lazy'}})}
var staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/VImg.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var VImgvue_type_script_lang_js_ = ({
  name: 'VImg',
  props: ['media', 'fixedSize', 'customClass', 'loading_method'],
  computed: {
    srcset() {
      if (this.fixedSize) return null;
      const {
        src,
        width
      } = this.media;
      const srcset = `${this.$image(src, '200x')} 100w'
      ${width >= 200 ? `, ${this.$image(src, '400x')} 200w` : ''}
      ${width >= 400 ? `, ${this.$image(src, '800x')} 400w` : ''}
      ${width >= 600 ? `, ${this.$image(src, '1200x')} 600w` : ''}
      ${width >= 800 ? `, ${this.$image(src, '1600x')} 800w` : ''}
      ${width >= 1000 ? `, ${this.$image(src, '2000x')} 1000w` : ''}
      ${width >= 1500 ? `, ${this.$image(src, '3000x')} 1500w` : ''}
      ${width >= 2000 ? `, ${this.$image(src, '4000x')} 2000w` : ''}`;
      return srcset;
    }

  }
});
;// CONCATENATED MODULE: ./src/scripts/vue/components/VImg.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_VImgvue_type_script_lang_js_ = (VImgvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1900);
;// CONCATENATED MODULE: ./src/scripts/vue/components/VImg.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.Z)(
  components_VImgvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var VImg = (component.exports);

/***/ }),

/***/ 6719:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TransitionExpand; }
});

;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/transitions/TransitionExpand.vue?vue&type=template&id=1b12723a&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"expand"},on:{"enter":_vm.enter,"after-enter":_vm.afterEnter,"leave":_vm.leave}},[_vm._t("default")],2)}
var staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/transitions/TransitionExpand.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var TransitionExpandvue_type_script_lang_js_ = ({
  name: 'TransitionExpand',
  props: {
    fixedEntryHeight: {
      type: String,
      required: false,
      default: null
    },
    linear_padding: {
      type: String,
      required: false,
      default: ''
    },
    linear_margin: {
      type: String,
      required: false,
      default: ''
    }
  },
  methods: {
    enter(element) {
      element.style.height = this.fixedEntryHeight || element.scrollHeight + 'px';
      element.style.opacity = 1;

      if (this.linear_padding !== '') {
        element.style.paddingTop = this.linear_padding;
        element.style.paddingBottom = this.linear_padding;
      }

      if (this.linear_margin !== '') {
        element.style.marginTop = this.linear_margin;
        element.style.marginBottom = this.linear_margin;
      }
    },

    afterEnter(element) {
      element.style.height = 'auto';
    },

    leave(element) {
      element.style.height = element.scrollHeight + 'px';
      setTimeout(() => {
        element.style.height = 0;
        element.style.opacity = 0;

        if (this.linear_padding !== '') {
          element.style.paddingTop = 0;
          element.style.paddingBottom = 0;
        }

        if (this.linear_margin !== '') {
          element.style.marginTop = 0;
          element.style.marginBottom = 0;
        }
      }, 50);
    }

  }
});
;// CONCATENATED MODULE: ./src/scripts/vue/transitions/TransitionExpand.vue?vue&type=script&lang=js&
 /* harmony default export */ var transitions_TransitionExpandvue_type_script_lang_js_ = (TransitionExpandvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js
var injectStylesIntoStyleTag = __webpack_require__(3379);
var injectStylesIntoStyleTag_default = /*#__PURE__*/__webpack_require__.n(injectStylesIntoStyleTag);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/styleDomAPI.js
var styleDomAPI = __webpack_require__(7795);
var styleDomAPI_default = /*#__PURE__*/__webpack_require__.n(styleDomAPI);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/insertBySelector.js
var insertBySelector = __webpack_require__(569);
var insertBySelector_default = /*#__PURE__*/__webpack_require__.n(insertBySelector);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js
var setAttributesWithoutAttributes = __webpack_require__(3565);
var setAttributesWithoutAttributes_default = /*#__PURE__*/__webpack_require__.n(setAttributesWithoutAttributes);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/insertStyleElement.js
var insertStyleElement = __webpack_require__(9216);
var insertStyleElement_default = /*#__PURE__*/__webpack_require__.n(insertStyleElement);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/styleTagTransform.js
var styleTagTransform = __webpack_require__(4589);
var styleTagTransform_default = /*#__PURE__*/__webpack_require__.n(styleTagTransform);
// EXTERNAL MODULE: ./node_modules/@ps-devs/shopify-webpack/node_modules/css-loader/dist/cjs.js??clonedRuleSet-5[0].rules[0].use[1]!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/transitions/TransitionExpand.vue?vue&type=style&index=0&id=1b12723a&scoped=true&lang=css&
var TransitionExpandvue_type_style_index_0_id_1b12723a_scoped_true_lang_css_ = __webpack_require__(9863);
;// CONCATENATED MODULE: ./node_modules/style-loader/dist/cjs.js!./node_modules/@ps-devs/shopify-webpack/node_modules/css-loader/dist/cjs.js??clonedRuleSet-5[0].rules[0].use[1]!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/transitions/TransitionExpand.vue?vue&type=style&index=0&id=1b12723a&scoped=true&lang=css&

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (styleTagTransform_default());
options.setAttributes = (setAttributesWithoutAttributes_default());

      options.insert = insertBySelector_default().bind(null, "head");
    
options.domAPI = (styleDomAPI_default());
options.insertStyleElement = (insertStyleElement_default());

var update = injectStylesIntoStyleTag_default()(TransitionExpandvue_type_style_index_0_id_1b12723a_scoped_true_lang_css_/* default */.Z, options);




       /* harmony default export */ var transitions_TransitionExpandvue_type_style_index_0_id_1b12723a_scoped_true_lang_css_ = (TransitionExpandvue_type_style_index_0_id_1b12723a_scoped_true_lang_css_/* default */.Z && TransitionExpandvue_type_style_index_0_id_1b12723a_scoped_true_lang_css_/* default.locals */.Z.locals ? TransitionExpandvue_type_style_index_0_id_1b12723a_scoped_true_lang_css_/* default.locals */.Z.locals : undefined);

;// CONCATENATED MODULE: ./src/scripts/vue/transitions/TransitionExpand.vue?vue&type=style&index=0&id=1b12723a&scoped=true&lang=css&

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1900);
;// CONCATENATED MODULE: ./src/scripts/vue/transitions/TransitionExpand.vue



;


/* normalize component */

var component = (0,componentNormalizer/* default */.Z)(
  transitions_TransitionExpandvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "1b12723a",
  null
  
)

/* harmony default export */ var TransitionExpand = (component.exports);

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [346,383,67,412,106], function() { return __webpack_exec__(1955); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ }
]);